/* ============================================
   ACCOUNTS - GESTIÓN DE CUENTAS MEJORADA
   Combina funcionalidad antigua + nuevas secciones dashboard
   ============================================ */

const __DEV__ = false; // Cambiar a true para debug
const log = () => {};
const warn = () => {};
const error = () => {};

// Helper para detectar trades en Break Even (±0.1% del balance)
function isBreakEvenTrade(trade, balance) {
    const profitUSD = parseFloat(trade.profitUSD || trade.profit_usd) || 0;
    const profitPercent = (profitUSD / balance) * 100;
    return profitPercent >= -0.1 && profitPercent <= 0.1;
}

// Obtener tursoClient de window (cargado por app.js)
let tursoClient = window.tursoClient || null;
let currentUserId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
let accounts = [];

function resolveCurrentUserId() {
    return (
        window.currentUserId ||
        sessionStorage.getItem('currentUserId') ||
        localStorage.getItem('currentUserId') ||
        sessionStorage.getItem('userId') ||
        localStorage.getItem('userId') ||
        null
    );
}

// ============================================
// 🔒 VERIFICACIÓN DE PLAN CON SERVIDOR
// ============================================
async function verifyUserPlanWithServer() {
    const client = window.tursoClient;
    if (!client) return null;
    
    try {
        const result = await client.execute({
            sql: 'SELECT user_plan FROM users WHERE id = ?',
            args: [currentUserId]
        });
        
        if (result && result.rows && result.rows.length > 0) {
            return result.rows[0].user_plan || 'free';
        }
    } catch (e) {
        
    }
    return null;
}

// ============================================
// NOTIFICACIONES
// ============================================
function showNotification(message, type = 'info', duration = 4000) {
    // Usar showAlert global si existe (desde config.js)
    if (window.showAlert && typeof window.showAlert === 'function') {
        // showAlert espera (title, message, type)
        const title = type === 'success' ? 'Exito' : 
                      type === 'error' ? 'Error' :
                      type === 'warning' ? 'Advertencia' : 'Informacion';
        return window.showAlert(title, message, type);
    }
    // Fallback a showToast si existe (desde config.js)
    if (window.showToast && typeof window.showToast === 'function') {
        return window.showToast(message, type, duration);
    }
    // Console fallback

}

// ============================================
// TOGGLE CARD ACTIONS
// ============================================
function toggleCardActions(btn) {
    const footer = btn.closest('.perf-card-toggle').nextElementSibling;
    const isHidden = footer.style.display === 'none';
    
    if (isHidden) {
        footer.style.display = 'flex';
        footer.style.maxHeight = '100px';
        footer.style.padding = '12px 0';
        btn.textContent = '▲ Cerrar';
    } else {
        footer.style.maxHeight = '0';
        footer.style.padding = '0';
        footer.style.display = 'none';
        btn.textContent = '▼ Opciones';
    }
}

// ============================================
// INICIALIZACIÓN
// ============================================

document.addEventListener('DOMContentLoaded', async () => {
    const loadingOverlay = document.getElementById('gestionLoadingOverlay');
    if (loadingOverlay) loadingOverlay.classList.add('active');

    currentUserId = resolveCurrentUserId();
    if (!currentUserId) {
        // Esperar a que app.js termine de inicializar la sesión
        for (let i = 0; i < 20 && !currentUserId; i++) {
            await new Promise(r => setTimeout(r, 100));
            currentUserId = resolveCurrentUserId();
        }
    }

    if (!currentUserId) {
        if (loadingOverlay) loadingOverlay.classList.remove('active');
        window.location.href = '/';
        return;
    }

    // 🔒 VERIFICACIÓN DE PLAN - Usuarios FREE no pueden acceder a esta página
    const userPlan = localStorage.getItem('userPlan') || 'free';
    if (userPlan === 'free') {
        if (loadingOverlay) loadingOverlay.classList.remove('active');
        window.location.href = '/404';
        return;
    }

    // Esperar a que tursoClient esté disponible
    let attempts = 0;
    while (!tursoClient && attempts < 20) {
        tursoClient = window.tursoClient;
        if (tursoClient) break;
        await new Promise(r => setTimeout(r, 100));
        attempts++;
    }

    if (!tursoClient) {
        if (loadingOverlay) loadingOverlay.classList.remove('active');
        return;
    }

    // 🔒 VERIFICACIÓN ADICIONAL - Confirmar plan con el servidor
    try {
        const serverUserPlan = await verifyUserPlanWithServer();
        if (serverUserPlan === 'free') {
            localStorage.setItem('userPlan', 'free'); // Corregir localStorage
            if (loadingOverlay) loadingOverlay.classList.remove('active');
            window.location.href = '/404';
            return;
        }
    } catch (e) {
        // Si falla verificación, confiar en localStorage
    }

    // Cargar datos
    await loadAllAccounts();
    
    // 🔒 OCULTAR SECCIONES PREMIUM SI NO ES UNLIMITED
    const badgesSection = document.getElementById('badgesSection');
    const evolutionSection = document.getElementById('evolutionSection');
    
    if (userPlan.toLowerCase() !== 'unlimited') {
        if (badgesSection) badgesSection.style.display = 'none';
        if (evolutionSection) evolutionSection.style.display = 'none';
    }
    
    // Renderizar secciones (en orden de aparición en la página)
    updateQuickStats();
    renderRiskAlerts();                 // SECTION 1
    if (window.renderPerformanceCardsNew) {
        window.renderPerformanceCardsNew();  // SECTION 2 - Nuevo diseño
    } else {
        renderPerformanceCards();              // Fallback al diseño antiguo
    }
    filterPerformanceCards('all');      // Aplicar filtro inicial para excluir archivadas
    renderTreemap();                    // SECTION 3
    renderBadges();                     // SECTION 4
    renderEvolutionChart();             // SECTION 5
    initGlobalPayoutsSection();          // SECTION 4 (Gestion) - Historial de Retiros

    // Verificar si journal.html solicitó abrir ajustes para una cuenta específica
    try {
        const pendingSettingsAccountId = localStorage.getItem('openSettingsForAccount');
        if (pendingSettingsAccountId) {
            localStorage.removeItem('openSettingsForAccount');
            setTimeout(() => {
                const account = accounts.find(a => a.id === pendingSettingsAccountId);
                if (account) {
                    window.showSettingsModal(pendingSettingsAccountId);
                }
            }, 300);
        }
    } catch (e) {
        // Ignorar errores de localStorage
    }

    if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
        loadingOverlay.setAttribute('aria-busy', 'false');
    }
});

/* ============================================
   GLOBAL PAYOUTS (GESTION) - HISTORIAL DE RETIROS
   ============================================ */

function initGlobalPayoutsSection() {
    const listEl = document.getElementById('globalPayoutList');
    if (!listEl) return; // Solo en gestion.html

    const openBtn = document.getElementById('openGlobalPayoutModalBtn');
    const rangeEl = document.getElementById('globalPayoutRange');

    const modal = document.getElementById('globalPayoutModal');
    const closeModalBtn = document.getElementById('closeGlobalPayoutModalBtn');
    const cancelModalBtn = document.getElementById('cancelGlobalPayoutModalBtn');
    const form = document.getElementById('globalPayoutForm');

    const previewModal = document.getElementById('globalPayoutPreviewModal');
    const closePreviewBtn = document.getElementById('closeGlobalPayoutPreviewBtn');
    const closePreviewBtn2 = document.getElementById('closeGlobalPayoutPreviewBtn2');
    const deleteBtn = document.getElementById('deleteGlobalPayoutBtn');

    const paginationWrap = document.getElementById('globalPayoutPagination');
    const prevPageBtn = document.getElementById('globalPayoutPrevPage');
    const nextPageBtn = document.getElementById('globalPayoutNextPage');
    const pageInfoEl = document.getElementById('globalPayoutPageInfo');

    const PAYOUTS_PAGE_SIZE = 4;
    let currentPayoutPage = 1;
    let lastFilteredPayouts = [];

    let lastLoadedPayouts = [];
    let selectedPayoutId = null;

    function open(el) {
        if (!el) return;
        el.classList.remove('hidden');
        el.classList.add('flex');
    }

    function close(el) {
        if (!el) return;
        el.classList.add('hidden');
        el.classList.remove('flex');
    }

    function formatMoney(amount) {
        const n = Number(amount);
        if (Number.isNaN(n)) return '$0.00';
        return `$${n.toFixed(2)}`;
    }

    function formatDate(dateStr) {
        if (!dateStr) return '--';
        const d = new Date(dateStr);
        if (Number.isNaN(d.getTime())) return '--';
        return d.toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: '2-digit' });
    }

    function normalizeNotes(value) {
        if (value === null || value === undefined) return '';
        const s = String(value).trim();
        if (!s) return '';
        const lower = s.toLowerCase();
        if (lower === 'null' || lower === 'undefined') return '';
        return s;
    }

    function daysAgoLabel(dateStr) {
        const d = new Date(dateStr);
        if (Number.isNaN(d.getTime())) return '—';
        const diffMs = Date.now() - d.getTime();
        const days = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
        if (days === 0) return 'Hoy';
        if (days === 1) return 'Hace 1 día';
        return `Hace ${days} días`;
    }

    function getRangeDays() {
        const v = rangeEl?.value || '30';
        if (v === 'all') return null;
        const days = parseInt(v, 10);
        return Number.isFinite(days) ? days : 30;
    }

    function startOfDay(d) {
        const x = new Date(d);
        x.setHours(0, 0, 0, 0);
        return x;
    }

    function todayISO() {
        return new Date().toISOString().split('T')[0];
    }

    function tomorrowISO() {
        const t = startOfDay(new Date());
        t.setDate(t.getDate() + 1);
        return t.toISOString().split('T')[0];
    }

    function isStrictlyFutureDateISO(dateStr) {
        if (!dateStr) return false;
        const d = new Date(dateStr);
        if (Number.isNaN(d.getTime())) return false;
        return startOfDay(d) > startOfDay(new Date());
    }

    function normalizePayoutStatus(status) {
        const s = (status || '').toString().trim().toLowerCase();
        if (!s) return null;
        if (s === 'processing' || s === 'en_proceso' || s === 'en proceso') return 'processing';
        if (s === 'sent' || s === 'pago_enviado' || s === 'pago enviado') return 'sent';
        if (s === 'completed' || s === 'completado') return 'completed';
        if (s === 'denied' || s === 'denegado') return 'denied';
        return s;
    }

    function statusMeta(status) {
        const s = normalizePayoutStatus(status) || 'processing';
        if (s === 'completed') {
            return {
                key: 'completed',
                label: 'Completado',
                amountClass: 'text-green-400',
                iconWrap: 'bg-gradient-to-br from-green-500 to-emerald-500',
                icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>'
            };
        }
        if (s === 'denied') {
            return {
                key: 'denied',
                label: 'Denegado',
                amountClass: 'text-red-400',
                iconWrap: 'bg-gradient-to-br from-red-600 to-rose-500',
                icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>'
            };
        }
        if (s === 'sent') {
            return {
                key: 'sent',
                label: 'Pago enviado',
                amountClass: 'text-cyan-300',
                iconWrap: 'bg-gradient-to-br from-cyan-600 to-blue-600',
                icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M12 22a10 10 0 100-20 10 10 0 000 20z"/>'
            };
        }
        return {
            key: 'processing',
            label: 'En proceso',
            amountClass: 'text-slate-200',
            iconWrap: 'bg-gradient-to-br from-slate-700 to-slate-600',
            icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>'
        };
    }

    function isCompletedByDate(dateStr) {
        if (!dateStr) return false;
        const payoutDay = new Date(dateStr);
        if (Number.isNaN(payoutDay.getTime())) return false;

        // Regla UX: hasta que pase 1 día+ del día previsto, no se marca completado.
        // => Solo es "Completado" si payout_date es ANTERIOR al día actual.
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);
        payoutDay.setHours(0, 0, 0, 0);
        return payoutDay < startOfToday;
    }

    function applyRangeFilter(payouts) {
        const days = getRangeDays();
        if (!days) return payouts;
        const cutoff = new Date();
        cutoff.setHours(0, 0, 0, 0);
        cutoff.setDate(cutoff.getDate() - days);
        return payouts.filter(p => {
            const d = new Date(p.payout_date);
            return !Number.isNaN(d.getTime()) && d >= cutoff;
        });
    }

    function populateAccountSelect() {
        const select = document.getElementById('globalPayoutAccountId');
        if (!select) return;

        const activeAccounts = (accounts || []).filter(a => a && a.id);
        select.innerHTML = activeAccounts.length
            ? activeAccounts.map(a => `<option value="${a.id}">${a.name}</option>`).join('')
            : '<option value="" disabled selected>No hay cuentas</option>';
    }

    async function fetchGlobalPayouts() {
        if (!tursoClient || !currentUserId) return [];
        try {
            const sqlWithStatus = `SELECT p.id, p.amount, p.payout_date, p.notes, p.created_at, p.status,
                             a.id AS account_id, a.name AS account_name
                      FROM payouts p
                      JOIN accounts a ON a.id = p.account_id
                      WHERE a.user_id = ?
                      ORDER BY p.payout_date DESC`;

            const sqlFallback = `SELECT p.id, p.amount, p.payout_date, p.notes, p.created_at,
                             a.id AS account_id, a.name AS account_name
                      FROM payouts p
                      JOIN accounts a ON a.id = p.account_id
                      WHERE a.user_id = ?
                      ORDER BY p.payout_date DESC`;

            let result;
            try {
                result = await tursoClient.execute({ sql: sqlWithStatus, args: [currentUserId] });
            } catch (err) {
                const msg = String(err && err.message ? err.message : err);
                if (/no such column: p\.status/i.test(msg)) {
                    result = await tursoClient.execute({ sql: sqlFallback, args: [currentUserId] });
                } else {
                    throw err;
                }
            }

            return (result.rows || []).map(r => ({
                id: r.id,
                amount: r.amount,
                payout_date: r.payout_date,
                notes: r.notes,
                created_at: r.created_at,
                status: normalizePayoutStatus(r.status),
                account_id: r.account_id,
                account_name: r.account_name || 'Cuenta'
            }));
        } catch (e) {
            return [];
        }
    }

    async function autoAdvancePayoutStatuses() {
        if (!tursoClient || !currentUserId) return 0;

        // processing -> sent (day-of or after)
        // sent -> completed (payout_date + 1 day)
        // completed/denied are terminal and never auto-changed.
        const accountIds = (accounts || []).filter(a => a && a.id && a.user_id === currentUserId).map(a => a.id);
        // Note: accounts in this file don't always include user_id; use subquery instead.

        const args = [currentUserId];

        const sqlSent = `UPDATE payouts
            SET status = 'sent'
            WHERE id IN (
                SELECT p.id
                FROM payouts p
                JOIN accounts a ON a.id = p.account_id
                WHERE a.user_id = ?
                  AND (p.status IS NULL OR p.status = '' OR LOWER(p.status) = 'processing')
                  AND DATE(p.payout_date) <= DATE('now')
            )`;

        const sqlCompleted = `UPDATE payouts
            SET status = 'completed'
            WHERE id IN (
                SELECT p.id
                FROM payouts p
                JOIN accounts a ON a.id = p.account_id
                WHERE a.user_id = ?
                  AND LOWER(p.status) = 'sent'
                  AND DATE(p.payout_date) <= DATE('now','-1 day')
            )`;

        let updated = 0;
        try {
            const r1 = await tursoClient.execute({ sql: sqlSent, args });
            updated += Number(r1.rowsAffected || 0);
        } catch (e) {
            // ignore
        }

        try {
            const r2 = await tursoClient.execute({ sql: sqlCompleted, args });
            updated += Number(r2.rowsAffected || 0);
        } catch (e) {
            // ignore
        }

        return updated;
    }

    async function setPayoutStatus(payoutId, newStatus) {
        if (!tursoClient) return false;
        const st = normalizePayoutStatus(newStatus);
        if (!payoutId || !st) return false;
        try {
            await tursoClient.execute({
                sql: 'UPDATE payouts SET status = ? WHERE id = ?',
                args: [st, payoutId]
            });
            return true;
        } catch (err) {
            const msg = String(err && err.message ? err.message : err);
            if (/no such column: status/i.test(msg)) {
                showNotification('Tu base de datos aún no tiene la columna de estado. Ejecuta el init/migración del worker.', 'warning');
            }
            return false;
        }
    }

    function renderGlobalPayoutStats(allPayouts, filteredPayouts) {
        const totalEl = document.getElementById('globalPayoutTotal');
        const countEl = document.getElementById('globalPayoutCount');
        const avgEl = document.getElementById('globalPayoutAvg');
        const lastEl = document.getElementById('globalPayoutLast');
        const lastSubEl = document.getElementById('globalPayoutLastSub');
        const hintEl = document.getElementById('globalPayoutHint');

        const total = allPayouts.reduce((s, p) => s + (Number(p.amount) || 0), 0);
        const filteredTotal = filteredPayouts.reduce((s, p) => s + (Number(p.amount) || 0), 0);
        const count = allPayouts.length;
        const filteredCount = filteredPayouts.length;
        const avg = filteredCount > 0 ? (filteredTotal / filteredCount) : 0;

        if (totalEl) totalEl.textContent = formatMoney(total);
        if (countEl) countEl.textContent = String(count);
        if (avgEl) avgEl.textContent = formatMoney(avg);

        if (allPayouts.length > 0) {
            const latest = allPayouts[0];
            if (lastEl) lastEl.textContent = formatMoney(latest.amount);
            if (lastSubEl) lastSubEl.textContent = daysAgoLabel(latest.payout_date);
        } else {
            if (lastEl) lastEl.textContent = '--';
            if (lastSubEl) lastSubEl.textContent = 'Sin registros';
        }

        if (hintEl) {
            const rangeDays = getRangeDays();
            hintEl.textContent = rangeDays ? `${filteredCount} en ${rangeDays} días` : `${filteredCount} total`;
        }
    }

    function renderGlobalPayoutPagination(totalItems) {
        const totalPages = Math.max(1, Math.ceil(totalItems / PAYOUTS_PAGE_SIZE));

        if (!paginationWrap || !prevPageBtn || !nextPageBtn || !pageInfoEl) return;

        if (totalItems <= PAYOUTS_PAGE_SIZE) {
            paginationWrap.classList.add('hidden');
            return;
        }

        paginationWrap.classList.remove('hidden');

        currentPayoutPage = Math.min(Math.max(1, currentPayoutPage), totalPages);
        pageInfoEl.textContent = `Página ${currentPayoutPage} de ${totalPages}`;

        prevPageBtn.disabled = currentPayoutPage <= 1;
        nextPageBtn.disabled = currentPayoutPage >= totalPages;

        prevPageBtn.classList.toggle('opacity-50', prevPageBtn.disabled);
        prevPageBtn.classList.toggle('cursor-not-allowed', prevPageBtn.disabled);
        nextPageBtn.classList.toggle('opacity-50', nextPageBtn.disabled);
        nextPageBtn.classList.toggle('cursor-not-allowed', nextPageBtn.disabled);
    }

    function renderGlobalPayoutList(payouts) {
        if (!listEl) return;
        if (!payouts || payouts.length === 0) {
            listEl.innerHTML = `
                <div class="bg-slate-900/50 border border-slate-700/50 rounded-xl p-4 text-sm text-slate-400">
                    No hay retiros en este rango.
                </div>
            `;

            if (paginationWrap) paginationWrap.classList.add('hidden');
            return;
        }

        lastFilteredPayouts = payouts;
        const totalPages = Math.max(1, Math.ceil(payouts.length / PAYOUTS_PAGE_SIZE));
        currentPayoutPage = Math.min(Math.max(1, currentPayoutPage), totalPages);
        const start = (currentPayoutPage - 1) * PAYOUTS_PAGE_SIZE;
        const pageItems = payouts.slice(start, start + PAYOUTS_PAGE_SIZE);

        renderGlobalPayoutPagination(payouts.length);

        listEl.innerHTML = pageItems.map(p => {
            const notes = normalizeNotes(p.notes);
            const subtitle = notes ? notes : 'Retiro registrado';

            const meta = statusMeta(p.status);
            const showActions = meta.key === 'sent';

            return `
                <div data-payout-id="${p.id}" role="button" tabindex="0" class="w-full text-left bg-slate-900/50 border border-slate-700/50 rounded-xl p-4 hover:border-cyan-500/30 transition-all group cursor-pointer">
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex items-center gap-4 min-w-0">
                            <div class="w-11 h-11 rounded-full ${meta.iconWrap} flex items-center justify-center flex-shrink-0">
                                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    ${meta.icon}
                                </svg>
                            </div>
                            <div class="min-w-0">
                                <div class="font-semibold text-white mb-1 truncate">${p.account_name || 'Cuenta'}</div>
                                <div class="flex items-center gap-2 text-xs text-slate-400">
                                    <span>${formatDate(p.payout_date)}</span>
                                    <span>•</span>
                                    <span class="truncate">${subtitle}</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-right flex-shrink-0">
                            <div class="text-lg sm:text-xl font-bold ${meta.amountClass}">+${formatMoney(p.amount)}</div>
                            <div class="text-xs text-slate-500">${meta.label}</div>
                            ${showActions ? `
                                <div class="flex items-center justify-end gap-2 mt-2">
                                    <button type="button" data-payout-action="set-status" data-payout-id="${p.id}" data-status="completed" class="px-2.5 py-1 text-xs font-semibold rounded-md bg-green-600/20 hover:bg-green-600/30 border border-green-500/30 text-green-200 transition-all">
                                        Completado
                                    </button>
                                    <button type="button" data-payout-action="set-status" data-payout-id="${p.id}" data-status="denied" class="px-2.5 py-1 text-xs font-semibold rounded-md bg-red-600/20 hover:bg-red-600/30 border border-red-500/30 text-red-200 transition-all">
                                        Denegado
                                    </button>
                                </div>
                            ` : ''}
                        </div>
                    </div>
                </div>
            `;
        }).join('');
    }

    function openPreview(payout) {
        if (!payout) return;
        selectedPayoutId = payout.id;

        const accEl = document.getElementById('previewPayoutAccount');
        const dateEl = document.getElementById('previewPayoutDate');
        const amountEl = document.getElementById('previewPayoutAmount');
        const notesEl = document.getElementById('previewPayoutNotes');

        if (accEl) accEl.textContent = payout.account_name || 'Cuenta';
        if (dateEl) dateEl.textContent = formatDate(payout.payout_date);
        if (amountEl) amountEl.textContent = formatMoney(payout.amount);
        if (notesEl) {
            const notes = normalizeNotes(payout.notes);
            notesEl.textContent = notes ? notes : '—';
        }

        open(previewModal);
    }

    async function refresh(options = {}) {
        const { resetPage = false } = options;
        if (resetPage) currentPayoutPage = 1;

        populateAccountSelect();
        let all = await fetchGlobalPayouts();
        // Auto-advance status based on date rules (processing->sent; sent->completed +1 day)
        const updated = await autoAdvancePayoutStatuses();
        if (updated > 0) {
            all = await fetchGlobalPayouts();
        }
        lastLoadedPayouts = all;
        const filtered = applyRangeFilter(all);
        renderGlobalPayoutStats(all, filtered);
        renderGlobalPayoutList(filtered);
    }

    // UI events
    openBtn?.addEventListener('click', () => {
        populateAccountSelect();
        open(modal);
        // UX: payout_date debe ser futuro (mínimo mañana)
        const dateEl = document.getElementById('globalPayoutDate');
        if (dateEl) {
            const min = tomorrowISO();
            dateEl.min = min;
            if (!dateEl.value || !isStrictlyFutureDateISO(dateEl.value)) {
                dateEl.value = min;
            }
        }
    });

    closeModalBtn?.addEventListener('click', () => close(modal));
    cancelModalBtn?.addEventListener('click', () => close(modal));

    closePreviewBtn?.addEventListener('click', () => close(previewModal));
    closePreviewBtn2?.addEventListener('click', () => close(previewModal));

    modal?.addEventListener('click', (e) => {
        if (e.target === modal) close(modal);
    });
    previewModal?.addEventListener('click', (e) => {
        if (e.target === previewModal) close(previewModal);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            close(modal);
            close(previewModal);
        }
    });

    rangeEl?.addEventListener('change', () => refresh({ resetPage: true }));

    prevPageBtn?.addEventListener('click', () => {
        if (currentPayoutPage <= 1) return;
        currentPayoutPage -= 1;
        renderGlobalPayoutList(lastFilteredPayouts);
    });

    nextPageBtn?.addEventListener('click', () => {
        const totalPages = Math.max(1, Math.ceil((lastFilteredPayouts || []).length / PAYOUTS_PAGE_SIZE));
        if (currentPayoutPage >= totalPages) return;
        currentPayoutPage += 1;
        renderGlobalPayoutList(lastFilteredPayouts);
    });

    listEl.addEventListener('click', async (e) => {
        const actionBtn = e.target.closest('[data-payout-action]');
        if (actionBtn) {
            const action = actionBtn.getAttribute('data-payout-action');
            const payoutId = actionBtn.getAttribute('data-payout-id');
            const status = actionBtn.getAttribute('data-status');

            if (action === 'set-status') {
                const payout = lastLoadedPayouts.find(p => String(p.id) === String(payoutId));
                const meta = statusMeta(payout?.status);
                if (!payout || meta.key !== 'sent') {
                    showNotification('Solo puedes cambiar el estado cuando esté en "Pago enviado".', 'warning');
                    return;
                }

                const target = normalizePayoutStatus(status);
                if (target === 'denied' && window.showConfirm && typeof window.showConfirm === 'function') {
                    const ok = await window.showConfirm({
                        title: 'Marcar como denegado',
                        message: '¿Seguro que quieres marcar este retiro como DENEGADO?',
                        confirmText: 'Denegar',
                        cancelText: 'Cancelar',
                        type: 'danger'
                    });
                    if (!ok) return;
                }

                const ok = await setPayoutStatus(payoutId, target);
                if (ok) {
                    showNotification('Estado actualizado', 'success');
                    await refresh();
                } else {
                    showNotification('No se pudo actualizar el estado', 'error');
                }
            }
            return;
        }

        const row = e.target.closest('[data-payout-id]');
        if (!row) return;
        const id = row.getAttribute('data-payout-id');
        const payout = lastLoadedPayouts.find(p => String(p.id) === String(id));
        openPreview(payout);
    });

    deleteBtn?.addEventListener('click', async () => {
        if (!selectedPayoutId) return;

        if (!window.showConfirm || typeof window.showConfirm !== 'function') {
            showNotification('No se pudo mostrar la confirmación. Recarga la página.', 'warning');
            return;
        }

        const ok = await window.showConfirm({
            title: 'Eliminar retiro',
            message: '¿Estás seguro de eliminar este retiro? Esta acción no se puede deshacer.',
            confirmText: 'Eliminar',
            cancelText: 'Cancelar',
            type: 'danger'
        });
        if (!ok) return;
        try {
            await tursoClient.execute({
                sql: 'DELETE FROM payouts WHERE id = ?',
                args: [selectedPayoutId]
            });
            showNotification('Retiro eliminado', 'success');
            selectedPayoutId = null;
            close(previewModal);
            await refresh();

            // Recargar para mantener consistencia con otras cards
            await loadAllAccounts();
            if (window.renderPerformanceCardsNew) {
                window.renderPerformanceCardsNew();
            } else {
                await renderPerformanceCards();
            }
        } catch (e) {
            showNotification('Error al eliminar el retiro', 'error');
        }
    });

    form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const accountId = document.getElementById('globalPayoutAccountId')?.value;
        const amount = document.getElementById('globalPayoutAmount')?.value;
        const date = document.getElementById('globalPayoutDate')?.value;
        const notes = document.getElementById('globalPayoutNotes')?.value;

        if (!accountId || !amount || !date) {
            showNotification('Completa los campos requeridos', 'warning');
            return;
        }

        if (!isStrictlyFutureDateISO(date)) {
            showNotification('La fecha del retiro debe ser futura (mínimo mañana).', 'warning');
            return;
        }

        try {
            const createdAt = new Date().toISOString();

            try {
                await tursoClient.execute({
                    sql: `INSERT INTO payouts (account_id, amount, payout_date, status, notes, created_at)
                          VALUES (?, ?, ?, ?, ?, ?)`,
                    args: [accountId, parseFloat(amount), date, 'processing', notes || null, createdAt]
                });
            } catch (err) {
                const msg = String(err && err.message ? err.message : err);
                if (/table payouts has no column named status/i.test(msg) || /no such column: status/i.test(msg)) {
                    // Backward-compat: DB aún no migrada
                    await tursoClient.execute({
                        sql: `INSERT INTO payouts (account_id, amount, payout_date, notes, created_at)
                              VALUES (?, ?, ?, ?, ?)`,
                        args: [accountId, parseFloat(amount), date, notes || null, createdAt]
                    });
                    showNotification('Retiro guardado, pero falta migración de estado (status).', 'warning');
                } else {
                    throw err;
                }
            }

            showNotification('Retiro registrado exitosamente', 'success');
            form.reset();
            close(modal);
            await refresh();

            // Recargar las cards (próximo payout, etc.)
            await loadAllAccounts();
            if (window.renderPerformanceCardsNew) {
                window.renderPerformanceCardsNew();
            } else {
                await renderPerformanceCards();
            }
        } catch (e) {
            showNotification('Error al registrar el retiro', 'error');
        }
    });

    // First load
    refresh();
}

// ============================================
// CARGAR CUENTAS Y MÉTRICAS
// ============================================

async function loadAllAccounts() {
    try {
        if (!tursoClient || !currentUserId) return;

        // Cargar cuentas ordenadas por is_primary (principal primero), luego por orden guardado en localStorage
        const result = await tursoClient.execute({
            sql: 'SELECT * FROM accounts WHERE user_id = ? ORDER BY is_primary DESC, created_at DESC',
            args: [currentUserId]
        });

        accounts = result.rows.map(row => ({
            id: row.id,
            name: row.name || 'Sin nombre',
            type: row.type || 'challenge_f1',
            balance: parseFloat(row.balance || 0),
            initial_balance: parseFloat(row.initial_balance || row.balance || 10000),
            status: row.status || 'active',
            priority: row.priority || 'medium',
            created_at: row.created_at,
            payout_date: row.payout_date,
            is_primary: Number(row.is_primary) || 0,
            is_archived: Number(row.is_archived) || 0,
            archived_at: row.archived_at,
            roi_objective: row.roi_objective ? parseFloat(row.roi_objective) : null,
            max_drawdown: row.max_drawdown ? parseFloat(row.max_drawdown) : null
        }));

        // Aplicar orden personalizado guardado en localStorage
        applyCustomAccountOrder();

        // Cargar métricas en paralelo
        await Promise.all(accounts.map(account => loadAccountMetrics(account)));

        // Cargar métricas de comportamiento y auto-actualizar status en paralelo
        await Promise.all(accounts.map(async (account) => {
            await loadAccountBehaviorMetrics(account);
            await autoUpdateAccountStatus(account);
        }));

        // Exponse accounts globalmente para que risk-analysis.js pueda acceder
        window.accounts = accounts;

        // Refrescar análisis de riesgo si ya está inicializado
        if (window.refreshRiskAnalysis && typeof window.refreshRiskAnalysis === 'function') {
            window.refreshRiskAnalysis();
        }

        return accounts;
    } catch (error) {
        return [];
    }
}

async function loadAccountMetrics(account) {
    try {
        if (!tursoClient) return;

        const safeInitialBalance = (account.initial_balance && account.initial_balance > 0)
            ? account.initial_balance
            : (account.balance || 10000);
        const result = await tursoClient.execute({
            sql: `SELECT 
                    COUNT(*) AS total_trades,
                    SUM(CASE WHEN profit_usd > 0 THEN 1 ELSE 0 END) AS wins,
                    SUM(profit_usd) AS total_profit_usd,
                    SUM(CASE WHEN profit_usd > 0 THEN profit_usd ELSE 0 END) AS gross_profit,
                    SUM(CASE WHEN profit_usd < 0 THEN ABS(profit_usd) ELSE 0 END) AS gross_loss,
                    MAX(CASE WHEN profit_usd < 0 THEN ABS(profit_usd) ELSE 0 END) AS max_loss,
                    SUM(CASE WHEN (ABS(profit_usd) / ?) * 100 <= 0.1 THEN 1 ELSE 0 END) AS be_count,
                    SUM(CASE WHEN profit_usd > 0 AND (ABS(profit_usd) / ?) * 100 > 0.1 THEN 1 ELSE 0 END) AS wins_ex_be,
                    SUM(CASE WHEN (ABS(profit_usd) / ?) * 100 > 0.1 THEN 1 ELSE 0 END) AS trades_ex_be
                 FROM trades
                 WHERE account_id = ?`,
            args: [safeInitialBalance, safeInitialBalance, safeInitialBalance, account.id]
        });

        if (result && result.rows && result.rows.length > 0) {
            const row = result.rows[0];
            const totalTrades = Number(row.total_trades || 0);
            const beCount = Number(row.be_count || 0);
            const winsExcludingBE = Number(row.wins_ex_be || 0);
            const totalTradesExcludingBE = Number(row.trades_ex_be || 0);
            const wins = Number(row.wins || 0);
            const totalProfit = Number(row.total_profit_usd || 0);
            const grossProfit = Number(row.gross_profit || 0);
            const grossLoss = Number(row.gross_loss || 0);

            account.metrics = {
                totalTrades,
                wins,
                beCount,
                totalProfit,
                grossProfit,
                grossLoss,
                winRate: totalTradesExcludingBE > 0 ? (winsExcludingBE / totalTradesExcludingBE) * 100 : 0,
                profitFactor: grossLoss === 0 ? (grossProfit > 0 ? 1.5 : 0) : Math.min((grossProfit / grossLoss), 10).toFixed(2),
                roi: safeInitialBalance ? ((totalProfit / safeInitialBalance) * 100).toFixed(2) : '0',
                drawdown: safeInitialBalance ? ((grossLoss / safeInitialBalance) * 100).toFixed(2) : '0'
            };
        } else {
            account.metrics = {
                totalTrades: 0,
                wins: 0,
                totalProfit: 0,
                grossProfit: 0,
                grossLoss: 0,
                winRate: 0,
                profitFactor: 0,
                roi: 0,
                drawdown: 0
            };
        }

        // Estado de profit
        account.profitStatus = account.metrics.totalProfit > 0 ? 'positive' : 
                               account.metrics.totalProfit < 0 ? 'negative' : 'neutral';

    } catch (error) {
        account.metrics = {
            totalTrades: 0,
            wins: 0,
            totalProfit: 0,
            winRate: 0,
            profitFactor: 0,
            roi: 0,
            drawdown: 0
        };
    }
}

async function loadAccountBehaviorMetrics(account) {
    try {
        if (!tursoClient) return;

        const result = await tursoClient.execute({
            sql: `SELECT profit_usd, lot_size, date, entry_time, timestamp
                  FROM trades
                  WHERE account_id = ?
                  ORDER BY date DESC, entry_time DESC
                  LIMIT 300`,
            args: [account.id]
        });

        const rows = result?.rows || [];
        const normalized = rows.map(r => {
            const lot = Number(r.lot_size || 0);
            const profit = Number(r.profit_usd || 0);
            const ts = getTradeTimestamp(r);
            return { lot, profit, ts };
        }).filter(t => Number.isFinite(t.lot) && t.lot > 0);

        if (normalized.length < 2) {
            account.behavior = {
                hasLotData: false,
                tradesAnalyzed: normalized.length,
                escalations: 0,
                lossEscalations: 0,
                revengeCount: 0,
                maxIncrease: 1,
                avgLot: 0,
                consistencyLabel: 'N/A',
                status: 'no-data',
                hasTimeData: false
            };
            return;
        }

        const sorted = [...normalized].sort((a, b) => {
            if (a.ts && b.ts) return a.ts - b.ts;
            return 0;
        });

        const lots = sorted.map(t => t.lot);
        const avgLot = lots.reduce((s, v) => s + v, 0) / lots.length;
        const variance = lots.reduce((s, v) => s + Math.pow(v - avgLot, 2), 0) / lots.length;
        const stdLot = Math.sqrt(variance);
        const cv = avgLot > 0 ? stdLot / avgLot : 0;
        const consistencyLabel = cv < 0.2 ? 'ALTA' : cv < 0.5 ? 'MEDIA' : 'BAJA';

        let escalations = 0;
        let lossEscalations = 0;
        let revengeCount = 0;
        let maxIncrease = 1;
        let hasTimeData = false;

        for (let i = 1; i < sorted.length; i++) {
            const prev = sorted[i - 1];
            const curr = sorted[i];
            if (!prev.lot || !curr.lot) continue;
            const ratio = curr.lot / prev.lot;
            if (ratio > maxIncrease) maxIncrease = ratio;

            if (ratio >= 1.5) {
                escalations++;
                if (prev.profit < 0) lossEscalations++;
            }

            if (prev.profit < 0 && prev.ts && curr.ts) {
                hasTimeData = true;
                const diff = curr.ts - prev.ts;
                if (diff > 0 && diff <= 15 * 60 * 1000) revengeCount++;
            }
        }

        let status = 'controlada';
        if (lossEscalations > 0 || revengeCount >= 2 || maxIncrease >= 2) {
            status = 'riesgo';
        } else if (cv >= 0.5 || escalations > 0 || revengeCount > 0) {
            status = 'inestable';
        } else if (cv < 0.2 && lossEscalations === 0 && revengeCount === 0) {
            status = 'consistente';
        }

        account.behavior = {
            hasLotData: true,
            tradesAnalyzed: sorted.length,
            escalations,
            lossEscalations,
            revengeCount,
            maxIncrease: Math.max(1, maxIncrease),
            avgLot,
            consistencyLabel,
            status,
            hasTimeData
        };
    } catch (e) {
        account.behavior = {
            hasLotData: false,
            tradesAnalyzed: 0,
            escalations: 0,
            lossEscalations: 0,
            revengeCount: 0,
            maxIncrease: 1,
            avgLot: 0,
            consistencyLabel: 'N/A',
            status: 'no-data',
            hasTimeData: false
        };
    }
}

function getTradeTimestamp(row) {
    if (row?.date && row?.entry_time) {
        const ts = new Date(`${row.date}T${row.entry_time}`).getTime();
        if (!Number.isNaN(ts)) return ts;
    }
    if (row?.timestamp) {
        const ts = new Date(row.timestamp).getTime();
        if (!Number.isNaN(ts)) return ts;
    }
    if (row?.date) {
        const ts = new Date(row.date).getTime();
        if (!Number.isNaN(ts)) return ts;
    }
    return null;
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function renderAccountRecaps() {
    const grid = document.getElementById('accountRecapsGrid');
    if (!grid) return;

    const activeAccounts = accounts.filter(a => !Number(a.is_archived));
    if (!activeAccounts.length) {
        grid.innerHTML = '<div class="text-sm text-slate-400">Sin cuentas disponibles.</div>';
        return;
    }

    const statusStyles = {
        consistente: {
            label: 'Consistente',
            badge: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
            border: 'border-emerald-500/30'
        },
        controlada: {
            label: 'Controlada',
            badge: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
            border: 'border-blue-500/30'
        },
        inestable: {
            label: 'Inestable',
            badge: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
            border: 'border-amber-500/30'
        },
        riesgo: {
            label: 'Riesgo alto',
            badge: 'bg-red-500/20 text-red-300 border-red-500/30',
            border: 'border-red-500/30'
        },
        'no-data': {
            label: 'Sin datos',
            badge: 'bg-slate-700/40 text-slate-300 border-slate-600/40',
            border: 'border-slate-700/40'
        }
    };

    grid.innerHTML = activeAccounts.map(account => {
        const behavior = account.behavior || { status: 'no-data', tradesAnalyzed: 0 };
        const style = statusStyles[behavior.status] || statusStyles['no-data'];
        const winRate = account.metrics?.winRate ? Number(account.metrics.winRate).toFixed(0) : '0';
        const pf = account.metrics?.profitFactor ? account.metrics.profitFactor : '0';
        const revengeValue = behavior.hasTimeData ? behavior.revengeCount : 'N/A';

        return `
            <div class="bg-slate-900/60 border ${style.border} rounded-xl p-4 shadow-lg">
                <div class="flex items-start justify-between gap-2">
                    <div>
                        <p class="text-sm font-bold text-white">${escapeHtml(account.name)}</p>
                        <p class="text-[11px] text-slate-400">${escapeHtml(account.type || 'Cuenta')}</p>
                    </div>
                    <span class="text-[11px] px-2 py-1 rounded-full border ${style.badge}">${style.label}</span>
                </div>

                <div class="mt-3 grid grid-cols-2 gap-2 text-xs">
                    <div class="bg-slate-800/60 rounded-lg p-2 border border-slate-700/60">
                        <p class="text-slate-400">Escaladas</p>
                        <p class="text-white font-semibold">${behavior.escalations ?? 0}</p>
                        <p class="text-[10px] text-slate-500">≥1.5x tamaño</p>
                    </div>
                    <div class="bg-slate-800/60 rounded-lg p-2 border border-slate-700/60">
                        <p class="text-slate-400">Revenge</p>
                        <p class="text-white font-semibold">${revengeValue}</p>
                        <p class="text-[10px] text-slate-500">≤15 min tras pérdida</p>
                    </div>
                    <div class="bg-slate-800/60 rounded-lg p-2 border border-slate-700/60">
                        <p class="text-slate-400">Consistencia</p>
                        <p class="text-white font-semibold">${behavior.consistencyLabel || 'N/A'}</p>
                        <p class="text-[10px] text-slate-500">Variación de lotes</p>
                    </div>
                    <div class="bg-slate-800/60 rounded-lg p-2 border border-slate-700/60">
                        <p class="text-slate-400">Trades</p>
                        <p class="text-white font-semibold">${behavior.tradesAnalyzed || 0}</p>
                        <p class="text-[10px] text-slate-500">Muestra</p>
                    </div>
                </div>

                <div class="mt-3 flex items-center justify-between text-[11px] text-slate-400">
                    <span>WR ${winRate}%</span>
                    <span>PF ${pf}</span>
                </div>
            </div>
        `;
    }).join('');
}

// ============================================
// AUTO-UPDATE STATUS BASED ON OBJECTIVE & DRAWDOWN
// ============================================
// Actualiza automáticamente el estado a "superado" cuando se alcanza el objetivo
// O a "quemada" cuando se alcanza el drawdown máximo
// También revierte a "active" si se incumple algún objetivo

async function autoUpdateAccountStatus(account) {
    try {
        if (!account || !account.metrics) return;

        const roi = parseFloat(account.metrics.roi) || 0;
        const initialBalance = Number(account.initial_balance || account.balance || 0);
        const totalProfit = Number(account.metrics.totalProfit || 0);
        const currentBalance = initialBalance ? (initialBalance + totalProfit) : Number(account.balance || 0);
        const ddPercent = initialBalance > 0 ? ((currentBalance - initialBalance) / initialBalance) * 100 : 0;
        const drawdownRaw = ddPercent < 0 ? Math.abs(ddPercent) : 0;
        const drawdown = Math.round(drawdownRaw * 10) / 10;

        // Usar objetivos personalizados si existen, sino los defaults
        let roiObjective = account.roi_objective;
        let maxDrawdown = account.max_drawdown;

        // Si no están seteados, usar defaults según tipo
        if (!roiObjective || !maxDrawdown) {
            if (account.type.includes('challenge_f1')) {
                roiObjective = roiObjective || 10;
                maxDrawdown = maxDrawdown || 10;
            } else if (account.type.includes('challenge_f2')) {
                roiObjective = roiObjective || 5;
                maxDrawdown = maxDrawdown || 10;
            } else if (account.type.includes('funded')) {
                // Fondeada: ROI custom, DD 10%
                maxDrawdown = maxDrawdown || 10;
            }
        }

        // ======== REVERTIR DE SUPERADO A ACTIVE ========
        if (account.status === 'superado' && roiObjective && roi < roiObjective) {
            if (!tursoClient) return;

            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ? WHERE id = ?',
                args: ['active', account.id]
            });

            account.status = 'active';
            showNotification(`⚠️ ${account.name}: ROI bajó por debajo del objetivo (${roi.toFixed(2)}% < ${roiObjective.toFixed(2)}%). Status: Activa`, 'warning', 5000);
            updateNotificationBadge();
            return;
        }

        // ======== REVERTIR DE BURNED A ACTIVE ========
        if (account.status === 'burned' && maxDrawdown && drawdown < maxDrawdown) {
            if (!tursoClient) return;

            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ? WHERE id = ?',
                args: ['active', account.id]
            });

            account.status = 'active';
            showNotification(`✅ ${account.name}: Drawdown se recuperó (${drawdown.toFixed(2)}% < ${maxDrawdown.toFixed(2)}%). Status: Activa`, 'info', 5000);
            updateNotificationBadge();
            return;
        }

        // ======== ACTIVAR SUPERADO ========
        // Verificar si se alcanzó el DD máximo -> QUEMADA
        if (maxDrawdown && account.status === 'active' && drawdown > 0) {
            const warningThreshold = Math.max(0, maxDrawdown - 1);
            if (drawdown >= warningThreshold && drawdown < maxDrawdown) {
                const warnKey = `ddWarn:${account.id}:${maxDrawdown}`;
                if (!sessionStorage.getItem(warnKey)) {
                    const msg = `⚠️ ${account.name}: le queda 1% para llegar al DD máximo (${drawdown.toFixed(2)}% / ${maxDrawdown.toFixed(2)}%).`;
                    if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                        try {
                            window.NotificationCenter.add({
                                type: 'warning',
                                title: 'Alerta Drawdown',
                                message: msg
                            });
                        } catch (e) {
                            showNotification(msg, 'warning', 5000);
                        }
                    } else {
                        showNotification(msg, 'warning', 5000);
                    }
                    sessionStorage.setItem(warnKey, 'true');
                    updateNotificationBadge();
                }
            }
        }

        if (maxDrawdown && drawdown >= maxDrawdown && account.status === 'active') {
            if (!tursoClient) return;

            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ? WHERE id = ?',
                args: ['burned', account.id]
            });

            account.status = 'burned';
            showNotification(`🔥 ${account.name}: DD máximo alcanzado (${drawdown.toFixed(2)}% / ${maxDrawdown.toFixed(2)}%). Status: Quemada`, 'error', 5000);
            
            // Notificar en el notificationBtn
            updateNotificationBadge();
            return;
        }

        // Verificar si se alcanzó el ROI objetivo -> SUPERADA
        if (roiObjective && roi >= roiObjective && account.status === 'active') {
            if (!tursoClient) return;

            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ? WHERE id = ?',
                args: ['superado', account.id]
            });

            account.status = 'superado';

            // Mostrar notificación
            const successMsg = `✅ ${account.name}: Objetivo alcanzado (ROI ${roi.toFixed(2)}% ≥ ${roiObjective.toFixed(2)}%). Status: Superado`;
            if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
                try {
                    window.NotificationCenter.add({
                        type: 'success',
                        title: 'Objetivo alcanzado',
                        message: `Enhorabuena, ${account.name} ha alcanzado el objetivo.`
                    });
                } catch (e) {
                    showNotification(successMsg, 'success', 5000);
                }
            } else {
                showNotification(successMsg, 'success', 5000);
            }
            
            // Notificar en el notificationBtn
            updateNotificationBadge();
        }

    } catch (error) {
        // Silencio en caso de error (no interrumpir la experiencia)
    }
}

// ============================================

function updateQuickStats() {
    const totalAccounts = accounts.length;
    const fundedAccounts = accounts.filter(a => a.type === 'funded').length;
    const challengeAccounts = accounts.filter(a => a.type.includes('challenge')).length;
    const profitAccounts = accounts.filter(a => a.metrics && a.metrics.totalProfit > 0).length;
    const totalBalance = accounts.reduce((sum, a) => sum + a.balance, 0);

    const el = (id) => document.getElementById(id);
    if (el('totalAccounts')) el('totalAccounts').textContent = totalAccounts;
    if (el('fundedAccounts')) el('fundedAccounts').textContent = fundedAccounts;
    if (el('challengeAccounts')) el('challengeAccounts').textContent = challengeAccounts;
    if (el('profitAccounts')) el('profitAccounts').textContent = profitAccounts;
    if (el('totalBalance')) el('totalBalance').textContent = `$${totalBalance.toFixed(2)}`;
}

// ============================================
// 1. RENDERIZAR TREEMAP
// ============================================

function renderTreemap() {
    const container = document.getElementById('treemapChart');
    if (!container) return;

    if (accounts.length === 0) {
        container.innerHTML = '<div class="empty-state"><div class="empty-state-icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18l-1.68 7.56a2 2 0 0 1-2 1.44H6.68a2 2 0 0 1-2-1.44L3 6z"/><path d="M21 6V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"/></svg></div><div class="empty-state-text">No tienes cuentas aún</div></div>';
        return;
    }

    const maxBalance = Math.max(...accounts.map(a => a.balance));
    container.innerHTML = '';

    accounts.forEach(account => {
        const width = Math.max(100, (account.balance / maxBalance) * 300);
        const height = Math.max(80, (account.balance / maxBalance) * 200);

        let bgColor;
        if (account.status === 'burned' || account.status === 'superado') {
            bgColor = '#90a4ae';
        } else if (account.profitStatus === 'positive') {
            bgColor = 'linear-gradient(135deg, rgba(0, 208, 132, 0.4), rgba(0, 208, 132, 0.15))';
        } else if (account.profitStatus === 'negative') {
            bgColor = 'linear-gradient(135deg, rgba(255, 107, 107, 0.4), rgba(255, 107, 107, 0.15))';
        } else {
            bgColor = 'linear-gradient(135deg, rgba(255, 215, 0, 0.4), rgba(255, 215, 0, 0.15))';
        }

        const item = document.createElement('div');
        item.className = 'treemap-item';
        item.style.width = width + 'px';
        item.style.height = height + 'px';
        item.style.background = bgColor;

        let profitText;
        let statusClass = '';
        if (account.status === 'burned') {
            profitText = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle; margin-right: 4px;"><path d="M12 2c1.5 1.5 3.5 3.5 3.5 5.5 0 1.5-1 3-2.5 3.5V12c0 2-1.5 3.5-3 4.5-.5.5-1 1-1 1.5 0 1.5 1 2.5 2.5 2.5S14 19.5 14 18c0-1.5-1-2.5-2-3v-1.5c1.5-.5 2.5-2 2.5-3.5 0-2-2-4-3.5-5.5z"/></svg> Quemada';
            statusClass = 'burned';
        } else if (account.status === 'superado') {
            profitText = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="vertical-align: middle; margin-right: 4px;"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg> Superada';
            statusClass = 'superado';
        } else {
            profitText = account.metrics.totalProfit > 0 ? `+$${account.metrics.totalProfit.toFixed(2)}` : 
                          account.metrics.totalProfit < 0 ? `-$${Math.abs(account.metrics.totalProfit).toFixed(2)}` : 'BE';
        }

        item.innerHTML = `
            <div class="treemap-item-content">
                <div class="treemap-item-name">${account.name}</div>
                <div class="treemap-item-balance">$${account.balance.toFixed(2)}</div>
                <div class="treemap-item-profit ${account.profitStatus} ${statusClass}">${profitText}</div>
            </div>
        `;

        container.appendChild(item);
    });
}

// ============================================
// 2. RENDERIZAR PERFORMANCE CARDS
// ============================================

async function renderPerformanceCards() {
    const container = document.getElementById('performanceGrid');
    if (!container) return;

    if (accounts.length === 0) {
        container.innerHTML = '<div class="empty-state"><div class="empty-state-icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg></div><div class="empty-state-text">No hay datos</div></div>';
        return;
    }

    // Cargar próximos payouts para todas las cuentas
    const nextPayouts = {};
    try {
        const today = new Date().toISOString().split('T')[0];
        const result = await tursoClient.execute({
            sql: `SELECT account_id, amount, payout_date 
                  FROM payouts 
                  WHERE payout_date >= ? 
                  ORDER BY payout_date ASC`,
            args: [today]
        });
        
        // Agrupar por cuenta y obtener solo el más cercano
        result.rows.forEach(row => {
            if (!nextPayouts[row.account_id]) {
                nextPayouts[row.account_id] = {
                    amount: row.amount,
                    date: row.payout_date
                };
            }
        });
    } catch (error) {

    }

    container.innerHTML = '';

    // Mostrar todas las cuentas (activas y archivadas)
    if (accounts.length === 0) {
        container.innerHTML = '<div class="empty-state"><div class="empty-state-icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg></div><div class="empty-state-text">No hay datos</div></div>';
        return;
    }

    accounts.forEach((account, index) => {
        const card = document.createElement('div');
        card.className = 'performance-card';
        card.setAttribute('data-type', account.type);
        // Marcar como archivada si is_archived = 1
        const cardStatus = account.is_archived ? 'archived' : (account.status || 'active');
        card.setAttribute('data-status', cardStatus);
        card.setAttribute('data-account-id', account.id);
        card.setAttribute('draggable', 'true');

        const metrics = account.metrics || {};
        const roi = isNaN(parseFloat(metrics.roi)) ? 0 : parseFloat(metrics.roi);
        const winRate = isNaN(metrics.winRate) ? 0 : parseFloat(metrics.winRate).toFixed(1);
        const profitFactor = isNaN(metrics.profitFactor) ? 0 : metrics.profitFactor;
        const drawdownValue = parseFloat(metrics.drawdown);
        
        // Calcular W/L/BE
        const totalTrades = metrics.totalTrades || 0;
        const wins = metrics.wins || 0;
        const beCount = metrics.beCount || 0;
        const losses = totalTrades - wins - beCount;

        const statusIcon = account.profitStatus === 'positive' ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle;"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>' : 
                          account.profitStatus === 'negative' ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle;"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>' : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle;"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        const typeEmoji = account.type.includes('challenge') ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle;"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>' : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle;"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>';
        const typeText = account.type.includes('challenge_f1') ? 'Challenge F1' : 
                        account.type.includes('challenge_f2') ? 'Challenge F2' : 'Fondeada';
        
        // Priority badge
        const priorityIcon = account.priority === 'high' ? '<svg width="10" height="10" viewBox="0 0 24 24" fill="#f44336" style="vertical-align: middle;"><circle cx="12" cy="12" r="10"/></svg>' : 
                            account.priority === 'medium' ? '<svg width="10" height="10" viewBox="0 0 24 24" fill="#ff9800" style="vertical-align: middle;"><circle cx="12" cy="12" r="10"/></svg>' : '<svg width="10" height="10" viewBox="0 0 24 24" fill="#4caf50" style="vertical-align: middle;"><circle cx="12" cy="12" r="10"/></svg>';
        const priorityText = account.priority === 'high' ? 'Alta' : 
                            account.priority === 'medium' ? 'Media' : 'Baja';
        
        // Escapar el nombre para uso seguro en atributos HTML y JS
        const escapedName = account.name.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;');
        
        // Próximo payout
        let payoutDisplay = '';
        const nextPayout = nextPayouts[account.id];
        if (nextPayout) {
            const payoutDate = new Date(nextPayout.date);
            if (!isNaN(payoutDate.getTime())) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                payoutDate.setHours(0, 0, 0, 0);
                const daysUntil = Math.ceil((payoutDate - today) / (1000 * 60 * 60 * 24));
                
                const formattedDate = payoutDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
                const amount = `$${parseFloat(nextPayout.amount).toFixed(2)}`;
                
                if (daysUntil > 0) {
                    payoutDisplay = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle; margin-right: 4px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> ${amount} • ${formattedDate} (${daysUntil}d)`;
                } else if (daysUntil === 0) {
                    payoutDisplay = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle; margin-right: 4px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> ${amount} • ¡Hoy!`;
                }
            }
        }

        card.innerHTML = `
            <div style="position: absolute; top: -16px; left: 50%; transform: translateX(-50%); background: linear-gradient(135deg, #ff9a3c, #ff6b35); border: 1.5px solid #ff9a3c; padding: 6px 18px; border-radius: 18px; font-size: 12px; color: #fff; font-weight: 700; box-shadow: 0 6px 20px rgba(255, 154, 60, 0.2); white-space: nowrap; z-index: 10;">
                $${account.balance.toFixed(2)}
            </div>
            <div class="perf-card-header">
                <div style="flex: 1; display: flex; flex-direction: column; align-items: center;">
                    <div class="perf-card-name">${statusIcon} ${account.name}</div>
                </div>
                <div class="perf-card-badges">
                    <span class="priority-badge" title="Prioridad: ${priorityText}" style="background: ${account.priority === 'high' ? 'rgba(255,107,107,0.2)' : account.priority === 'medium' ? 'rgba(255,193,7,0.2)' : 'rgba(76,175,80,0.2)'}; padding: 4px 8px; border-radius: 4px; font-size: 12px; display: inline-flex; align-items: center; gap: 4px;">
                        ${priorityIcon} ${priorityText}
                    </span>
                </div>
            </div>
            <div class="perf-card-subheader" style="display: flex; justify-content: space-between; align-items: center; font-size: 12px; color: #90a4ae; margin-bottom: 8px;">
                <div>${typeEmoji} ${typeText}</div>
                ${payoutDisplay ? `<div style="color: #ff9a3c;">${payoutDisplay}</div>` : ''}
            </div>

            <div class="perf-metrics">
                <div class="perf-metric">
                    <div class="perf-metric-label">Win Rate</div>
                    <div class="perf-metric-value ${parseFloat(winRate) === 0 ? 'white-text' : parseFloat(winRate) < 35 ? 'negative' : parseFloat(winRate) < 50 ? 'warning' : 'positive'}">${winRate}%</div>
                </div>
                <div class="perf-metric">
                    <div class="perf-metric-label">Profit Factor</div>
                    <div class="perf-metric-value ${parseFloat(profitFactor) === 0 ? 'white-text' : profitFactor > 1.5 ? 'positive' : profitFactor > 1 ? 'neutral' : 'negative'}">${isNaN(profitFactor) || profitFactor === 'NaN' ? '0' : profitFactor}x</div>
                </div>
                <div class="perf-metric">
                    <div class="perf-metric-label">ROI</div>
                    <div class="perf-metric-value ${roi === 0 ? 'white-text' : roi > 0 ? 'positive' : 'negative'}">${roi > 0 ? '+' : ''}${isNaN(roi) ? 0 : roi}%</div>
                </div>
                <div class="perf-metric">
                    <div class="perf-metric-label">Drawdown</div>
                    <div class="perf-metric-value ${drawdownValue === 0 || isNaN(drawdownValue) ? 'white-text' : 'negative'}">${drawdownValue === 0 || isNaN(drawdownValue) ? '0' : '-' + drawdownValue.toFixed(1)}%</div>
                </div>
            </div>

            <div class="perf-progress-label">
                <span style="font-size: 11px; color: #90a4ae;">0R</span>
                <span style="font-size: 11px; color: #90a4ae;">50R</span>
                <span style="font-size: 11px; color: #90a4ae;">100R</span>
            </div>

            <div class="perf-progress-bar">
                <div class="perf-progress-fill" style="width: ${Math.max(0, Math.min(100, roi))}%"></div>
            </div>

            <div style="text-align: center; font-size: 12px; color: ${roi > 0 ? '#00d084' : roi < 0 ? '#ff6b6b' : '#90a4ae'}; margin-top: 4px; font-weight: 600; padding-bottom: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.08);">
                ${roi > 0 ? '+' : ''}${roi.toFixed(1)}R • <span style="color: #4ade80;">W:${wins}</span> <span style="color: #f87171;">L:${losses}</span> <span style="color: #94a3b8;">BE:${beCount}</span>
            </div>

            <div class="perf-card-toggle">
                <button class="perf-toggle-btn" onclick="toggleCardActions(this)" style="background: none; border: none; color: #90a4ae; cursor: pointer; font-size: 14px; padding: 8px 12px; width: 100%; text-align: center; transition: all 0.2s;">
                    ▼ Opciones
                </button>
            </div>

            <div class="perf-card-footer" style="display: none; max-height: 0; overflow: hidden; transition: max-height 0.3s ease, padding 0.3s ease;">
                <div style="display: flex; gap: 6px; width: 100%;">
                    <button class="perf-card-btn" onclick="toggleFavoriteAccount(event, '${account.id}')" style="background: none; border: 1px solid #90a4ae; color: ${Number(account.is_primary) === 1 ? '#ffd700' : '#90a4ae'}; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1;" title="Cuenta Principal">${Number(account.is_primary) === 1 ? '★' : '☆'}</button>
                    <button class="perf-card-btn" onclick="goToAccountJournal('${account.id}')" style="background: none; border: 1px solid #90a4ae; color: #ff9a3c; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1;" title="Ver Journal"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg></button>
                    <button class="perf-card-btn" onclick="showSettingsModal('${account.id}')" style="background: none; border: 1px solid #90a4ae; color: #1abc9c; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1;" title="Ajustes"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/><circle cx="6" cy="6" r="1.5"/><circle cx="6" cy="18" r="1.5"/><circle cx="18" cy="10" r="1.5"/><circle cx="18" cy="14" r="1.5"/></svg></button>
                    <button class="perf-card-btn" onclick="showDeleteConfirmation('${account.id}', '${escapedName}')" style="background: none; border: 1px solid #90a4ae; color: #ff6b6b; cursor: pointer; font-size: 16px; padding: 6px 8px; border-radius: 6px; transition: all 0.2s; flex: 1;" title="Eliminar"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>
                </div>
            </div>
        `;

        container.appendChild(card);
    });
    
    // Aplicar filtro activo actual (o 'all' por defecto) después de renderizar
    const activeFilterBtn = document.querySelector('.perf-filter-btn.active');
    const currentFilter = activeFilterBtn ? activeFilterBtn.getAttribute('data-filter') : 'all';
    filterPerformanceCards(currentFilter);
}

// ============================================
// 3. FILTROS PERFORMANCE
// ============================================

document.addEventListener('DOMContentLoaded', () => {
    const perfFilterBtns = document.querySelectorAll('.perf-filter-btn');
    perfFilterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            perfFilterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            const filter = btn.getAttribute('data-filter');
            filterPerformanceCards(filter);
        });
    });
});

function filterPerformanceCards(filterType) {
    const cards = document.querySelectorAll('.performance-card');
    cards.forEach(card => {
        const cardType = card.getAttribute('data-type');
        const cardStatus = card.getAttribute('data-status');
        let shouldShow = false;

        if (filterType === 'all') {
            shouldShow = cardStatus !== 'archived';
        } else if (filterType === 'archived') {
            shouldShow = cardStatus === 'archived';
        } else {
            shouldShow = cardType.includes(filterType) && cardStatus !== 'archived';
        }

        card.style.display = shouldShow ? '' : 'none';
    });
}

// ============================================
// 4. BADGES Y LOGROS
// ============================================

function renderBadges() {
    const container = document.getElementById('badgesGrid');
    if (!container) return;

    const badges = calculateBadges();
    container.innerHTML = '';

    badges.forEach(badge => {
        const badgeCard = document.createElement('div');
        badgeCard.className = `badge-card ${badge.locked ? 'locked' : ''}`;

        badgeCard.innerHTML = `
            ${badge.locked ? '<div class="badge-locked-icon">🔒</div>' : ''}
            <span class="badge-icon">${badge.icon}</span>
            <div class="badge-title">${badge.title}</div>
            <div class="badge-description">${badge.description}</div>
            <div class="badge-value">${badge.value}</div>
        `;

        container.appendChild(badgeCard);
    });
}

function calculateBadges() {
    const badges = [];

    // 1. MEJOR WIN RATE
    const bestWinRateAccount = accounts.reduce((best, acc) => {
        const winRate = (acc.metrics && !isNaN(acc.metrics.winRate)) ? acc.metrics.winRate : 0;
        const bestWinRate = (best && best.metrics && !isNaN(best.metrics.winRate)) ? best.metrics.winRate : 0;
        return (!best || winRate > bestWinRate) ? acc : best;
    }, null);

    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>',
        title: 'Más Consistente',
        description: 'Mejor Win Rate',
        value: bestWinRateAccount && bestWinRateAccount.metrics ? `${bestWinRateAccount.metrics.winRate.toFixed(1)}%` : '--',
        locked: !bestWinRateAccount || !bestWinRateAccount.metrics || bestWinRateAccount.metrics.totalTrades < 5
    });

    // 2. MEJOR ROI
    const bestRoiAccount = accounts.reduce((best, acc) => {
        const accRoi = isNaN(parseFloat(acc.metrics.roi)) ? 0 : parseFloat(acc.metrics.roi);
        const bestRoi = best ? (isNaN(parseFloat(best.metrics.roi)) ? 0 : parseFloat(best.metrics.roi)) : -Infinity;
        return (!best || accRoi > bestRoi) ? acc : best;
    }, null);

    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>',
        title: 'Mejor ROI',
        description: 'Mayor rendimiento %',
        value: bestRoiAccount ? `+${isNaN(parseFloat(bestRoiAccount.metrics.roi)) ? 0 : bestRoiAccount.metrics.roi}%` : '--',
        locked: !bestRoiAccount || parseFloat(bestRoiAccount.metrics.roi) <= 0
    });

    // 3. MEJOR PROFIT FACTOR
    const bestPFAccount = accounts.reduce((best, acc) => {
        const accPF = isNaN(parseFloat(acc.metrics.profitFactor)) ? 0 : parseFloat(acc.metrics.profitFactor);
        const bestPF = best ? (isNaN(parseFloat(best.metrics.profitFactor)) ? 0 : parseFloat(best.metrics.profitFactor)) : -Infinity;
        return (!best || accPF > bestPF) ? acc : best;
    }, null);

    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="9" r="2"/><path d="M9 11v8m0 0l-3-3m3 3l3-3m6-13v8m0 0l3-3m-3 3l-3-3"/></svg>',
        title: 'Mejor Balance',
        description: 'Mejor Profit Factor',
        value: bestPFAccount ? (isNaN(parseFloat(bestPFAccount.metrics.profitFactor)) ? '0' : `${bestPFAccount.metrics.profitFactor}x`) : '--',
        locked: !bestPFAccount || parseFloat(bestPFAccount.metrics.profitFactor) < 1.2
    });

    // 4. TOTAL TRADES
    const totalTrades = accounts.reduce((sum, a) => {
        const trades = (a.metrics && !isNaN(a.metrics.totalTrades)) ? a.metrics.totalTrades : 0;
        return sum + trades;
    }, 0);
    
    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>',
        title: 'Trader Activo',
        description: 'Total de trades',
        value: totalTrades,
        locked: totalTrades < 20
    });

    // 5. TOTAL PROFIT
    const totalProfit = accounts.reduce((sum, a) => {
        const profit = (a.metrics && !isNaN(a.metrics.totalProfit)) ? a.metrics.totalProfit : 0;
        return sum + profit;
    }, 0);

    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
        title: 'Mayor Ganancia',
        description: 'Profit total',
        value: `$${totalProfit.toFixed(2)}`,
        locked: totalProfit <= 0
    });

    // 6. CUENTAS EN PROFIT
    const profitCount = accounts.filter(a => a.metrics && a.metrics.totalProfit > 0).length;
    const totalAccounts = accounts.length;
    const profitPercentage = totalAccounts > 0 ? ((profitCount/totalAccounts) * 100).toFixed(0) : 0;

    badges.push({
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>',
        title: 'En Ganancia',
        description: `${profitCount}/${totalAccounts} cuentas`,
        value: `${profitPercentage}%`,
        locked: profitCount === 0
    });

    return badges;
}

// ============================================
// 5. GRÁFICO DE EVOLUCIÓN MENSUAL
// ============================================

async function renderEvolutionChart() {
    try {
        if (!tursoClient || !currentUserId) return;

        const monthlyData = [];
        const today = new Date();
        
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
            const monthKey = date.toLocaleString('es-ES', { month: 'short', year: '2-digit' });
            
            const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
            const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            
            const result = await tursoClient.execute({
                sql: `SELECT SUM(profit_usd) as total_profit 
                     FROM trades 
                     WHERE account_id IN (SELECT id FROM accounts WHERE user_id = ?) 
                     AND date BETWEEN ? AND ?`,
                args: [currentUserId, 
                       monthStart.toISOString().split('T')[0],
                       monthEnd.toISOString().split('T')[0]]
            });
            
            const profit = result.rows[0]?.total_profit ? parseFloat(result.rows[0].total_profit) : 0;
            monthlyData.push({ month: monthKey, profit });
        }

        const ctx = document.getElementById('evolutionChart');
        if (!ctx) return;

        const profits = monthlyData.map(d => d.profit || 0); // Asegurar que sean números
        
        // Calcular métricas solo con todos los meses (incluyendo 0 para mostrar realidad)
        const bestMonth = profits.length > 0 ? Math.max(...profits) : 0;
        const worstMonth = profits.length > 0 ? Math.min(...profits) : 0;
        const totalProfit = profits.reduce((a, b) => (a || 0) + (b || 0), 0);
        const avgMonth = profits.length > 0 ? totalProfit / 12 : 0; // Promedio sobre 12 meses
        
        // Calcular tendencia: comparar últimos 3 meses vs 3 anteriores
        const recentSum = profits.slice(-3).reduce((a, b) => (a || 0) + (b || 0), 0); // Últimos 3
        const previousSum = profits.slice(-6, -3).reduce((a, b) => (a || 0) + (b || 0), 0); // 3 anteriores
        const trend = recentSum > previousSum ? '📈 Mejorando' : recentSum < previousSum ? '📉 Decayendo' : '➡️ Estable';

        new Chart(ctx, {
            type: 'line',
            data: {
                labels: monthlyData.map(d => d.month),
                datasets: [{
                    label: 'Profit Mensual ($)',
                    data: profits,
                    borderColor: '#1abc9c',
                    backgroundColor: 'rgba(26, 188, 156, 0.1)',
                    borderWidth: 3,
                    fill: true,
                    tension: 0.4,
                    pointRadius: 5,
                    pointBackgroundColor: '#1abc9c',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    pointHoverRadius: 7
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        display: true,
                        labels: { color: '#e0e0e0', font: { size: 12, weight: 'bold' } }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid: { color: 'rgba(255,255,255,0.06)' },
                        ticks: { color: '#90a4ae' }
                    },
                    x: {
                        grid: { display: false },
                        ticks: { color: '#90a4ae' }
                    }
                }
            }
        });

        const el = (id) => document.getElementById(id);
        if (el('bestMonthValue')) el('bestMonthValue').textContent = `$${(bestMonth || 0).toFixed(2)}`;
        if (el('worstMonthValue')) el('worstMonthValue').textContent = `$${(worstMonth || 0).toFixed(2)}`;
        if (el('avgMonthValue')) el('avgMonthValue').textContent = `$${(avgMonth || 0).toFixed(2)}`;
        if (el('trendValue')) el('trendValue').textContent = trend;
        
        // Información adicional
        if (el('totalProfitValue')) el('totalProfitValue').textContent = `$${(totalProfit || 0).toFixed(2)}`;
        
        const profitMonths = profits.filter(p => p > 0).length;
        const profitMonthsPercent = profits.length > 0 ? ((profitMonths / 12) * 100).toFixed(0) : 0;
        if (el('profitMonthsValue')) el('profitMonthsValue').textContent = `${profitMonths}/12 (${profitMonthsPercent}%)`;

    } catch (error) {
    }
}

// ============================================
// 6. RISK ALERTS
// ============================================

function renderRiskAlerts() {
    const container = document.getElementById('riskAlertsContainer');
    if (!container) return;

    // Verificar si las alertas ya se mostraron en esta sesión
    const sessionKey = `riskAlerts_shown_${currentUserId}`;
    const alertsShown = sessionStorage.getItem(sessionKey);
    
    const alerts = calculateRiskAlerts();
    const countElement = document.getElementById('riskAlertsCount');
    const fabBadge = document.getElementById('riskAlertsFabBadge');
    const fab = document.getElementById('riskAlertsFab');
    const panel = document.getElementById('riskAlertsPanel');

    // Actualizar contadores
    if (countElement) countElement.textContent = alerts.length;
    if (fabBadge) fabBadge.textContent = alerts.length;

    if (alerts.length === 0) {
        container.innerHTML = `
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 120px; color: #90a4ae;">
                <div style="font-size: 32px; margin-bottom: 8px;"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#00d084" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg></div>
                <div style="font-size: 13px; text-align: center; font-weight: 600;">¡Todo bajo control!</div>
                <div style="font-size: 11px; margin-top: 4px;">Ninguna cuenta está en zona de peligro</div>
            </div>
        `;
        if (fab) fab.style.display = 'none';
        if (panel) panel.style.display = 'none';
        return;
    }

    // Si ya se mostraron en esta sesión, ocultar el panel automáticamente
    if (alertsShown === 'true') {
        if (panel) panel.style.display = 'none';
        if (fab) fab.style.display = 'flex';
    } else {
        // Primera vez que se muestran en esta sesión
        if (panel) panel.style.display = 'flex';
        if (fab) fab.style.display = 'none';
        // Marcar como mostradas
        sessionStorage.setItem(sessionKey, 'true');
    }

    container.innerHTML = '';

    alerts.forEach((alert, index) => {
        const card = document.createElement('div');
        card.className = `risk-alert-card ${alert.severity}`;
        card.style.animationDelay = `${index * 0.05}s`;

        card.innerHTML = `
            <div class="risk-alert-header">
                <div class="risk-alert-info">
                    <div class="risk-alert-name">${alert.accountName}</div>
                    <div class="risk-alert-severity ${alert.severity}">${alert.severity}</div>
                </div>
                <button class="risk-alert-close-btn" onclick="closeRiskAlert(this)">✕</button>
            </div>

            <div class="risk-alert-content">
                <div class="risk-alert-item">
                    <span class="risk-alert-item-label">DD:</span>
                    <span class="risk-alert-item-value">${alert.drawdown}%</span>
                </div>
                <div class="risk-alert-item">
                    <span class="risk-alert-item-label">Límite:</span>
                    <span class="risk-alert-item-value">${alert.riskLimit}</span>
                </div>
                <div class="risk-alert-item">
                    <span class="risk-alert-item-label">Margen:</span>
                    <span class="risk-alert-item-value">${alert.margin}%</span>
                </div>
                <div class="risk-alert-item">
                    <span class="risk-alert-item-label">Balance:</span>
                    <span class="risk-alert-item-value">$${alert.balance}</span>
                </div>
            </div>

            <div class="risk-alert-recommendation">
                ${alert.recommendation}
            </div>
        `;

        container.appendChild(card);
    });
}

function calculateRiskAlerts() {
    const alerts = [];
    const ACCOUNT_LOSS_THRESHOLD = 10;    // >= 10% = pérdida permanente de cuenta
    const CRITICAL_THRESHOLD = 9;         // > 9% = estado crítico
    const HIGH_THRESHOLD = 4;             // > 4% = riesgo alto (puede perder por daily loss)
    const MEDIUM_THRESHOLD = 2;           // > 2% = moderado

    accounts.forEach(account => {
        const drawdown = parseFloat(account.metrics.drawdown);
        
        if (isNaN(drawdown) || drawdown === 0 || account.status === 'archived') return;  // No mostrar alertas si no hay DD
        
        if (drawdown >= ACCOUNT_LOSS_THRESHOLD) {
            // ACCOUNT LOST - Permanente
            alerts.push({
                accountName: account.name,
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="9"/><line x1="9" y1="15" x2="15" y2="15"/></svg>',
                severity: 'account-lost',
                drawdown: drawdown.toFixed(1),
                riskLimit: '10%',
                margin: (ACCOUNT_LOSS_THRESHOLD - drawdown).toFixed(1),
                balance: account.balance.toFixed(2),
                recommendation: 'Cuenta perdida. No es posible continuar operando.'
            });
        } else if (drawdown > CRITICAL_THRESHOLD) {
            // CRITICAL - Pausa inmediata
            alerts.push({
                accountName: account.name,
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
                severity: 'critical',
                drawdown: drawdown.toFixed(1),
                riskLimit: '10%',
                margin: (ACCOUNT_LOSS_THRESHOLD - drawdown).toFixed(1),
                balance: account.balance.toFixed(2),
                recommendation: 'PAUSA INMEDIATA. Estás a punto de perder la cuenta.'
            });
        } else if (drawdown > HIGH_THRESHOLD) {
            // HIGH - Riesgo de daily loss
            alerts.push({
                accountName: account.name,
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
                severity: 'high',
                drawdown: drawdown.toFixed(1),
                riskLimit: '10%',
                margin: (ACCOUNT_LOSS_THRESHOLD - drawdown).toFixed(1),
                balance: account.balance.toFixed(2),
                recommendation: 'Riesgo alto. Puedes perder por daily loss. Reduce posiciones.'
            });
        } else if (drawdown > MEDIUM_THRESHOLD) {
            // MEDIUM - Monitorear
            alerts.push({
                accountName: account.name,
                icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
                severity: 'medium',
                drawdown: drawdown.toFixed(1),
                riskLimit: '10%',
                margin: (ACCOUNT_LOSS_THRESHOLD - drawdown).toFixed(1),
                balance: account.balance.toFixed(2),
                recommendation: 'Monitorea de cerca. Sé selectivo con nuevas operaciones.'
            });
        }
    });

    return alerts.sort((a, b) => {
        const severityOrder = { 'account-lost': 0, critical: 1, high: 2, medium: 3 };
        return severityOrder[a.severity] - severityOrder[b.severity];
    });
}

// ============================================
// 7. MODALES - CREAR Y EDITAR CUENTAS
// ============================================

// MOSTRAR MODAL DE CREAR CUENTA
window.showAccountModal = function() {
    const modal = document.getElementById('accountModal');
    if (modal) {
        modal.style.display = 'flex';
        document.getElementById('accountForm').reset();
    }
}

// CERRAR MODAL DE CREAR CUENTA
window.closeAccountModal = function() {
    const modal = document.getElementById('accountModal');
    if (modal) {
        modal.style.display = 'none';
        document.getElementById('accountForm').reset();
    }
}

// MOSTRAR MODAL DE EDITAR CUENTA
window.showSettingsModal = function(accountId) {
    const modal = document.getElementById('settingsModal');
    if (!modal) return;

    const account = accounts.find(a => a.id === accountId);
    if (!account) return;

    // Llenar formulario con datos de la cuenta
    document.getElementById('settingsAccountId').value = accountId;
    document.getElementById('settingsName').value = account.name || '';
    document.getElementById('settingsType').value = account.type || '';
    document.getElementById('settingsStatus').value = account.status || 'active';
    document.getElementById('settingsPriority').value = account.priority || 'medium';
    document.getElementById('settingsPayout').value = account.payout_date || '';

    // Mostrar advertencia si cuenta está quemada
    const statusWarning = document.getElementById('statusWarning');
    if (statusWarning) {
        if (account.status === 'burned' || account.status === 'superado') {
            statusWarning.style.display = 'block';
        } else {
            statusWarning.style.display = 'none';
        }
    }

    modal.style.display = 'flex';
}

// CERRAR MODAL DE EDITAR CUENTA
window.closeSettingsModal = function() {
    const modal = document.getElementById('settingsModal');
    if (modal) {
        modal.style.display = 'none';
        document.getElementById('settingsForm').reset();
    }
}

// NAVEGAR AL JOURNAL DE UNA CUENTA
window.goToAccountJournal = function(accountId) {
    const account = accounts.find(a => a.id === accountId);
    if (account) {
        localStorage.setItem('selectedAccountId', accountId);
        localStorage.setItem('selectedAccountName', account.name);
    }
    window.location.href = '/journal';
}

// MANEJAR ENVÍO DE FORMULARIO - CREAR CUENTA
document.addEventListener('DOMContentLoaded', () => {
    const accountForm = document.getElementById('accountForm');
    if (accountForm) {
        accountForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            const name = document.getElementById('accountName').value;
            const type = document.getElementById('accountType').value;
            const balance = parseFloat(document.getElementById('accountBalance').value);

            if (!name || !type || !balance) {
                showNotification('Completa todos los campos', 'warning');
                return;
            }

            try {
                if (!tursoClient || !currentUserId) {
                    showNotification('Error: Cliente no disponible', 'error');
                    return;
                }

                // Generar ID único para la cuenta
                const accountId = window.generateId ? window.generateId() : `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;

                // Insertar nueva cuenta
                const result = await tursoClient.execute({
                    sql: `INSERT INTO accounts (id, user_id, name, type, balance, initial_balance, status, priority, created_at)
                          VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                    args: [
                        accountId,
                        currentUserId,
                        name,
                        type,
                        balance,
                        balance,
                        'active',
                        'medium',
                        new Date().toISOString()
                    ]
                });

                showNotification('Cuenta creada exitosamente', 'success');
                closeAccountModal();
                
                // 🔄 Redirigir a journal para que se inicialice con la nueva cuenta
                setTimeout(() => {
                    window.location.href = '/journal';
                }, 1500);

            } catch (error) {
                showNotification('Error al crear la cuenta', 'error');
            }
        });
    }
});

// MANEJAR ENVÍO DE FORMULARIO - EDITAR CUENTA
document.addEventListener('DOMContentLoaded', () => {
    const settingsForm = document.getElementById('settingsForm');
    if (settingsForm) {
        settingsForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            let accountUpdated = false;

            const accountId = document.getElementById('settingsAccountId').value;
            const name = document.getElementById('settingsName').value;
            const type = document.getElementById('settingsType').value;
            const status = document.getElementById('settingsStatus').value;
            const priority = document.getElementById('settingsPriority').value;
            const roiObjective = parseFloat(document.getElementById('settingsRoiObjective').value) || null;
            const maxDrawdown = parseFloat(document.getElementById('settingsMaxDrawdown').value) || null;

            if (!accountId || !name) {
                showNotification('Completa los campos requeridos', 'warning');
                return;
            }

            try {
                if (!tursoClient) {
                    showNotification('Error: Cliente no disponible', 'error');
                    return;
                }

                // Actualizar cuenta
                await tursoClient.execute({
                    sql: `UPDATE accounts 
                          SET name = ?, type = ?, status = ?, priority = ?, roi_objective = ?, max_drawdown = ?
                          WHERE id = ?`,
                    args: [name, type, status, priority, roiObjective, maxDrawdown, accountId]
                });
                accountUpdated = true;

                // Si es cuenta sincronizada y existen duplicados legacy con el mismo mt_account_number,
                // propagar el nombre para evitar que "rebote" después de refrescos.
                if (currentUserId) {
                    try {
                        const mtLookup = await tursoClient.execute({
                            sql: 'SELECT mt_account_number FROM accounts WHERE id = ? LIMIT 1',
                            args: [accountId]
                        });

                        const mtAccountNumber = mtLookup?.rows?.[0]?.mt_account_number;
                        if (mtAccountNumber) {
                            await tursoClient.execute({
                                sql: `UPDATE accounts
                                      SET name = ?
                                      WHERE user_id = ? AND mt_account_number = ?`,
                                args: [name, currentUserId, mtAccountNumber]
                            });
                        }
                    } catch (propagationError) {
                        warn('No se pudo propagar rename en duplicados legacy:', propagationError);
                    }
                }

                showNotification('Cuenta actualizada exitosamente', 'success');
                closeSettingsModal();

                // Recargar cuentas y renderizar
                try {
                    await loadAllAccounts();
                    updateQuickStats();
                    renderTreemap();
                    if (window.renderPerformanceCardsNew && typeof window.renderPerformanceCardsNew === 'function') {
                        window.renderPerformanceCardsNew();
                    } else {
                        renderPerformanceCards();
                    }
                    renderBadges();
                } catch (refreshError) {
                    warn('Cuenta guardada pero fallo al refrescar UI:', refreshError);
                }

            } catch (error) {
                if (accountUpdated) {
                    showNotification('Cuenta actualizada. Refresca la vista si no ves cambios al instante.', 'warning');
                } else {
                    showNotification('Error al actualizar la cuenta', 'error');
                }
            }
        });
    }
});

// Cerrar modales al hacer click en el fondo
document.addEventListener('DOMContentLoaded', () => {
    const modals = document.querySelectorAll('.modal');
    modals.forEach(modal => {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.style.display = 'none';
            }
        });
    });
});

// ============================================
// ============================================
// DRAG AND DROP - REORDENAR CARDS CON LOCALSTORAGE
// ============================================

let draggedAccountId = null;

// Guardar el orden personalizado en localStorage
function saveCustomAccountOrder() {
    try {
        const accountOrder = accounts.map(a => a.id);
        localStorage.setItem(`accountOrder_${currentUserId}`, JSON.stringify(accountOrder));
    } catch (e) {
        
    }
}

// Aplicar el orden personalizado guardado
function applyCustomAccountOrder() {
    try {
        const saved = localStorage.getItem(`accountOrder_${currentUserId}`);
        if (saved) {
            const accountOrder = JSON.parse(saved);
            // Reordenar accounts según el orden guardado
            const orderedAccounts = [];
            accountOrder.forEach(id => {
                const account = accounts.find(a => a.id === id);
                if (account) orderedAccounts.push(account);
            });
            // Agregar cuentas nuevas que no estaban en el orden guardado
            accounts.forEach(account => {
                if (!orderedAccounts.find(a => a.id === account.id)) {
                    orderedAccounts.push(account);
                }
            });
            accounts = orderedAccounts;
        }
    } catch (e) {
        
    }
}

document.addEventListener('dragstart', (e) => {
    if (e.target.classList.contains('performance-card')) {
        draggedAccountId = e.target.getAttribute('data-account-id');
        e.target.style.opacity = '0.5';
        e.dataTransfer.effectAllowed = 'move';
        
        // Mostrar zona de archivo/desarchivar
        const archiveZone = document.getElementById('archiveZone');
        if (archiveZone) {
            archiveZone.style.display = 'flex';
            
            // Detectar si estamos en vista de archivadas
            const activeFilterBtn = document.querySelector('.perf-filter-btn.active');
            const currentFilter = activeFilterBtn ? activeFilterBtn.getAttribute('data-filter') : 'all';
            
            const archiveIcon = document.getElementById('archiveIcon');
            const archiveText = document.getElementById('archiveText');
            
            if (currentFilter === 'archived') {
                archiveIcon.textContent = '↩️';
                archiveText.textContent = 'Suelta para desarchivar';
            } else {
                archiveIcon.textContent = '📦';
                archiveText.textContent = 'Suelta para archivar';
            }
        }
    }
});

document.addEventListener('dragover', (e) => {
    const archiveZone = document.getElementById('archiveZone');
    
    if (archiveZone && e.clientX !== undefined) {
        const rect = archiveZone.getBoundingClientRect();
        const isOverArchive = e.clientX >= rect.left && 
                              e.clientX <= rect.right && 
                              e.clientY >= rect.top && 
                              e.clientY <= rect.bottom;
        
        if (isOverArchive) {
            archiveZone.classList.add('active');
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
        } else {
            archiveZone.classList.remove('active');
        }
    }
    
    if (e.target.classList.contains('performance-card') && draggedAccountId) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        e.target.style.borderTop = '2px solid #1abc9c';
    }
});

document.addEventListener('dragleave', (e) => {
    if (e.target.classList.contains('performance-card')) {
        e.target.style.borderTop = '';
    }
});

document.addEventListener('drop', (e) => {
    const archiveZone = document.getElementById('archiveZone');
    
    // Verificar si se soltar sobre la zona de archivo/desarchivar
    if (archiveZone) {
        const rect = archiveZone.getBoundingClientRect();
        const isOverArchive = e.clientX >= rect.left && 
                              e.clientX <= rect.right && 
                              e.clientY >= rect.top && 
                              e.clientY <= rect.bottom;
        
        if (isOverArchive && draggedAccountId) {
            e.preventDefault();
            archiveZone.classList.remove('active');
            
            // Detectar si estamos en vista de archivadas
            const activeFilterBtn = document.querySelector('.perf-filter-btn.active');
            const currentFilter = activeFilterBtn ? activeFilterBtn.getAttribute('data-filter') : 'all';
            
            const accountIndex = accounts.findIndex(a => a.id === draggedAccountId);
            if (accountIndex !== -1) {
                const newStatus = currentFilter === 'archived' ? 'active' : 'archived';
                accounts[accountIndex].status = newStatus;
                
                // Actualizar en BD
                updateAccountStatus(draggedAccountId, newStatus).then(() => {
                    // Cambiar filtro según la acción
                    if (newStatus === 'archived') {
                        showNotification('📦 Cuenta archivada. Se eliminará automáticamente en 48 horas', 'success', 3000);
                        // Recargar página para actualizar el estado
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    } else {
                        showNotification('Cuenta desarchivada correctamente', 'success', 3000);
                        // Recargar página para actualizar el estado
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    }
                });
            }
            
            draggedAccountId = null;
            return;
        }
    }
    
    // Lógica original de reordenamiento
    if (e.target.classList.contains('performance-card') && draggedAccountId) {
        e.preventDefault();
        e.target.style.borderTop = '';
        
        const targetAccountId = e.target.getAttribute('data-account-id');
        
        if (draggedAccountId !== targetAccountId) {
            const draggedIndex = accounts.findIndex(a => a.id === draggedAccountId);
            const targetIndex = accounts.findIndex(a => a.id === targetAccountId);
            
            if (draggedIndex !== -1 && targetIndex !== -1) {
                [accounts[draggedIndex], accounts[targetIndex]] = [accounts[targetIndex], accounts[draggedIndex]];
                saveCustomAccountOrder();
                renderPerformanceCards();
            }
        }
    }
    
    draggedAccountId = null;
    if (archiveZone) {
        archiveZone.style.display = 'none';
        archiveZone.classList.remove('active');
    }
});

document.addEventListener('dragend', (e) => {
    e.target.style.opacity = '1';
    
    const archiveZone = document.getElementById('archiveZone');
    if (archiveZone) {
        archiveZone.style.display = 'none';
        archiveZone.classList.remove('active');
    }
    
    draggedAccountId = null;
});

// ============================================
// FAVORITOS Y ELIMINACIÓN DE CUENTAS
// ============================================

// MARCAR/DESMARCAR CUENTA COMO PRINCIPAL (FAVORITA)
window.toggleFavoriteAccount = async function(event, accountId) {
    event.preventDefault();
    event.stopPropagation();
    
    // Usar tursoClient fresco desde window (evitar closure stale)
    const client = tursoClient || window.tursoClient;
    if (!client) {
        showNotification('Error: Cliente no disponible, recarga la página', 'error');
        return;
    }

    // Buscar en accounts local y también en window.accounts como fallback
    const account = accounts.find(a => a.id === accountId) 
                 || (window.accounts || []).find(a => a.id === accountId);
    if (!account) {
        showNotification('Cuenta no encontrada', 'warning');
        return;
    }
    
    const isCurrentPrimary = Number(account.is_primary) === 1 || account.is_primary === '1';
    
    try {
        if (!isCurrentPrimary) {
            // Primero, desmarcar TODAS las demás cuentas
            const allAccounts = accounts.length > 0 ? accounts : (window.accounts || []);
            const otherPrimaries = allAccounts.filter(a => (Number(a.is_primary) === 1 || a.is_primary === '1'));
            for (let other of otherPrimaries) {
                try {
                    await client.execute({
                        sql: 'UPDATE accounts SET is_primary = 0 WHERE id = ?',
                        args: [other.id]
                    });
                    other.is_primary = 0;
                } catch (err) {
                    // silently fail
                }
            }
            
            // Ahora marcar esta como principal
            await client.execute({
                sql: 'UPDATE accounts SET is_primary = 1 WHERE id = ?',
                args: [accountId]
            });
            account.is_primary = 1;
            showNotification(`${account.name} es ahora tu cuenta principal`, 'success');
        } else {
            // Desmarcar (quitar como principal)
            await client.execute({
                sql: 'UPDATE accounts SET is_primary = 0 WHERE id = ?',
                args: [accountId]
            });
            account.is_primary = 0;
            showNotification(`☆ ${account.name} desmarcada como principal`, 'info');
        }
    } catch (error) {
        showNotification('Error al cambiar cuenta principal', 'error');
        return;
    }
        
    // Renderizar para actualizar UI (separado del try principal para no enmascarar éxito)
    try {
        if (typeof window.renderPerformanceCardsNew === 'function') {
            window.renderPerformanceCardsNew();
        } else if (typeof renderPerformanceCards === 'function') {
            renderPerformanceCards();
        }
    } catch (renderError) {
        // silently fail
    }
}

// CONFIRMAR ELIMINACIÓN DE CUENTA
let accountToDelete = null;

window.showDeleteConfirmation = function(accountId, accountName) {
    let account = null;
    
    // Buscar la cuenta - puede ser array o objeto
    if (Array.isArray(window.accounts)) {
        account = window.accounts.find(a => a.id === accountId);
    } else if (typeof window.accounts === 'object' && window.accounts) {
        account = window.accounts[accountId];
    }
    
    accountToDelete = { id: accountId, name: accountName };
    
    const modal = document.getElementById('confirmDeleteModal');
    const nameDisplay = document.getElementById('deleteAccountName');
    const archiveButtonText = document.getElementById('archiveButtonText');
    
    if (nameDisplay) {
        nameDisplay.textContent = accountName;
    }
    
    if (archiveButtonText) {
        archiveButtonText.textContent = account?.is_archived ? 'Desarchivar' : 'Archivar';
    }
    
    if (modal) {
        modal.style.display = 'flex';
    }
}

// Alias para compatibilidad con performance-cards.js
window.openDeleteConfirmModal = window.showDeleteConfirmation;

window.closeConfirmDeleteModal = function() {
    const modal = document.getElementById('confirmDeleteModal');
    if (modal) {
        modal.style.display = 'none';
    }
    accountToDelete = null;
}

window.confirmArchiveAccount = async function() {
    if (!accountToDelete) return;
    
    const accountId = accountToDelete.id;
    const accountName = accountToDelete.name;
    
    // Buscar la cuenta - puede ser array u objeto
    let account = null;
    if (Array.isArray(accounts)) {
        account = accounts.find(a => a.id === accountId);
    } else if (typeof accounts === 'object' && accounts) {
        account = accounts[accountId];
    }
    
    closeConfirmDeleteModal();
    
    // Si ya está archivado, desarchivarlo; si no, archivarlo
    if (account?.is_archived) {
        await unarchiveAccount(accountId, accountName);
    } else {
        await archiveAccount(accountId, accountName);
    }
}

window.confirmPermanentDelete = async function() {
    if (!accountToDelete || !accountToDelete.name) {
        showNotification('Error: No se pudo obtener la información de la cuenta', 'error');
        return;
    }
    
    // Guardar los datos ANTES de cerrar el modal (que pone accountToDelete = null)
    const accountData = { id: accountToDelete.id, name: accountToDelete.name };
    
    // Cerrar el modal de confirmación anterior
    closeConfirmDeleteModal();
    
    // Restaurar los datos
    accountToDelete = accountData;
    
    // Usar showConfirm genérico de notifications.js para confirmación
    const confirmed = await window.showConfirm({
        title: 'Eliminar permanentemente',
        message: `¿Estás seguro de que deseas eliminar permanentemente la cuenta "<strong>${accountData.name}</strong>"? Esta acción NO se puede deshacer. Se eliminarán todos los datos, historiales y configuraciones asociados.`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        type: 'warning',
        hideIcon: true
    });
    
    if (confirmed) {
        await window.executePermanentDelete();
    } else {
        // Usuario canceló
        accountToDelete = null;
    }
}

// Ejecutar la eliminación permanente después de la confirmación final
window.executePermanentDelete = async function() {
    if (!accountToDelete) {
        showNotification('Error: No se pudo identificar la cuenta a eliminar', 'error');
        return;
    }
    
    const accountId = accountToDelete.id;
    const accountName = accountToDelete.name;
    
    // Ejecutar eliminación permanente
    await permanentDeleteAccount(accountId, accountName);
    
    accountToDelete = null;
}

// ARCHIVAR CUENTA (se eliminará en 48h)
async function archiveAccount(accountId, accountName) {
    try {
        if (!tursoClient) {
            showNotification('Error: Cliente no disponible', 'error');
            return;
        }

        // Archivar la cuenta en lugar de eliminarla
        const now = new Date().toISOString();
        await tursoClient.execute({
            sql: 'UPDATE accounts SET is_archived = 1, archived_at = ? WHERE id = ?',
            args: [now, accountId]
        });
        
        // Remover del array local
        accounts = accounts.filter(a => a.id !== accountId);
        
        // Usar el nombre pasado como parámetro
        const displayName = accountName || 'Cuenta';
        accountToDelete = null;
        
        // Mostrar confirmación
        showNotification(`📦 Cuenta "${displayName}" archivada. Se eliminará automáticamente en 48 horas`, 'success', 3000);

        // Recargar página para actualizar el estado
        setTimeout(() => {
            window.location.reload();
        }, 1500);
        
    } catch (error) {
        showNotification('No se pudo archivar la cuenta. Intenta de nuevo.', 'error');
    }
}

// DESARCHIVIZAR CUENTA
async function unarchiveAccount(accountId, accountName) {
    try {
        if (!tursoClient) {
            showNotification('Error: Cliente no disponible', 'error');
            return;
        }

        // Desarchivizar la cuenta
        await tursoClient.execute({
            sql: 'UPDATE accounts SET is_archived = 0, archived_at = NULL WHERE id = ?',
            args: [accountId]
        });
        
        // Actualizar en el array local
        const account = accounts.find(a => a.id === accountId);
        if (account) {
            account.is_archived = 0;
            account.archived_at = null;
        }
        
        const displayName = accountName || 'Cuenta';
        accountToDelete = null;
        
        showNotification(`✅ Cuenta "${displayName}" desarchivizada`, 'success', 3000);

        // Recargar página para actualizar el estado
        setTimeout(() => {
            window.location.reload();
        }, 500);
        
    } catch (error) {
        showNotification('No se pudo desarchivizar la cuenta. Intenta de nuevo.', 'error');
    }
}

// ELIMINAR CUENTA PERMANENTEMENTE
async function permanentDeleteAccount(accountId, accountName) {
    try {
        if (!tursoClient) {
            showNotification('Error: Cliente no disponible', 'error');
            return;
        }

        // Obtener número de cuenta MT si existe
        const accountRecord = accounts.find(a => a.id === accountId);
        const accountNumber = accountRecord && accountRecord.mt_account_number ? String(accountRecord.mt_account_number) : null;

        // Primero eliminar todos los trades asociados
        await tursoClient.execute({
            sql: 'DELETE FROM trades WHERE account_id = ?',
            args: [accountId]
        });

        // Eliminar instalaciones asociadas (por account_id y/o número de cuenta)
        if (accountNumber) {
            await tursoClient.execute({
                sql: 'DELETE FROM installations WHERE account_id = ? OR account = ? OR UPPER(installation_id) LIKE ?',
                args: [accountId, accountNumber, `%_${accountNumber}`.toUpperCase()]
            });
        } else {
            await tursoClient.execute({
                sql: 'DELETE FROM installations WHERE account_id = ?',
                args: [accountId]
            });
        }

        // Eliminar plan asociado a la cuenta (si existe)
        await tursoClient.execute({
            sql: 'DELETE FROM trading_plans WHERE account_id = ?',
            args: [accountId]
        });

        // Luego eliminar la cuenta
        await tursoClient.execute({
            sql: 'DELETE FROM accounts WHERE id = ?',
            args: [accountId]
        });
        
        // Remover del array local
        accounts = accounts.filter(a => a.id !== accountId);
        
        const displayName = accountName || 'Cuenta';
        accountToDelete = null;
        
        // Mostrar confirmación
        showNotification(`🗑️ Cuenta "${displayName}" eliminada permanentemente`, 'success', 5000);

        // Renderizar con el nuevo estilo
        try { window.renderPerformanceCardsNew && window.renderPerformanceCardsNew(); } catch (e) {}
        try { renderTreemap(); } catch (e) {}
        try { renderBadges(); } catch (e) {}

        setTimeout(() => {
            window.location.reload();
        }, 800);
        
    } catch (error) {
        showNotification('No se pudo eliminar la cuenta. Intenta de nuevo.', 'error');
    }
}

async function updateAccountStatus(accountId, newStatus) {
    try {
        if (!tursoClient) {
            showNotification('Error: Cliente no disponible', 'error');
            return;
        }

        // Si se archiva, actualizar is_archived y archived_at
        if (newStatus === 'archived') {
            const now = new Date().toISOString();
            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ?, is_archived = 1, archived_at = ? WHERE id = ?',
                args: [newStatus, now, accountId]
            });
        } 
        // Si se desarchiva, limpiar is_archived y archived_at
        else {
            await tursoClient.execute({
                sql: 'UPDATE accounts SET status = ?, is_archived = 0, archived_at = NULL WHERE id = ?',
                args: [newStatus, accountId]
            });
            
            // Actualizar en el array local
            const account = accounts.find(a => a.id === accountId);
            if (account) {
                account.status = newStatus;
                account.is_archived = 0;
                account.archived_at = null;
            }
        }
        
        // Actualizar en el array local
        const account = accounts.find(a => a.id === accountId);
        if (account) {
            account.status = newStatus;
            account.is_archived = newStatus === 'archived' ? 1 : 0;
            account.archived_at = newStatus === 'archived' ? new Date().toISOString() : null;
        }
        
        return true;
    } catch (error) {
        showNotification('No se pudo actualizar el estado. Intenta de nuevo.', 'error');
        return false;
    }
}
// Toggle Risk Alerts panel visibility
window.toggleRiskPanel = function() {
    const panel = document.getElementById('riskAlertsPanel');
    const fab = document.getElementById('riskAlertsFab');
    
    if (panel) {
        const isVisible = panel.style.display !== 'none';
        panel.style.display = isVisible ? 'none' : 'flex';
    }
}

// Close individual risk alert
window.closeRiskAlert = function(btn) {
    const card = btn.closest('.risk-alert-card');
    if (card) {
        card.style.animation = 'slideOutAlert 0.3s ease-out forwards';
        setTimeout(() => {
            card.remove();
            
            // Update count if panel exists
            const container = document.getElementById('riskAlertsContainer');
            const countElement = document.getElementById('riskAlertsCount');
            const fabBadge = document.getElementById('riskAlertsFabBadge');
            const fab = document.getElementById('riskAlertsFab');
            
            if (container && countElement) {
                const remaining = container.querySelectorAll('.risk-alert-card').length;
                countElement.textContent = remaining;
                
                if (fabBadge) fabBadge.textContent = remaining;
                if (fab && remaining === 0) fab.style.display = 'none';
            }
        }, 300);
    }
}

/* ============================================
   SETTINGS MODAL - TABS & PAYOUTS & NOTES
   ============================================ */

let currentAccountIdForSettings = null;
let currentMonthOffset = 0;

// Switch between settings tabs
window.switchSettingsTab = function(tabName) {
    // Remove active class from all tabs and content
    document.querySelectorAll('.settings-tab').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.settings-tab-content').forEach(content => content.classList.remove('active'));
    
    // Add active class to selected tab and content
    const selectedTab = document.querySelector(`[data-tab="${tabName}"]`);
    const selectedContent = document.getElementById(`tab${tabName.charAt(0).toUpperCase() + tabName.slice(1)}`);
    
    if (selectedTab) selectedTab.classList.add('active');
    if (selectedContent) selectedContent.classList.add('active');
    
    // Load data for specific tabs
    if (tabName === 'payouts') {
        loadPayouts();
    } else if (tabName === 'notes') {
        loadMonthlyNotes();
    }
}

// Modified showSettingsModal to support new tabs
const originalShowSettingsModal = window.showSettingsModal;
window.showSettingsModal = function(accountId) {
    currentAccountIdForSettings = accountId;
    currentMonthOffset = 0;
    
    const modal = document.getElementById('settingsModal');
    if (!modal) return;

    const account = accounts.find(a => a.id === accountId);
    if (!account) return;

    // Fill general form with account data
    document.getElementById('settingsAccountId').value = accountId;
    document.getElementById('settingsName').value = account.name || '';
    document.getElementById('settingsType').value = account.type || '';
    document.getElementById('settingsStatus').value = account.status || 'active';
    document.getElementById('settingsPriority').value = account.priority || 'medium';

    // Llenar campos de objetivos con defaults si no existen
    let roiObjective = account.roi_objective;
    let maxDrawdown = account.max_drawdown;

    // Aplicar defaults según tipo si no están seteados
    if (!roiObjective) {
        roiObjective = account.type.includes('challenge_f1') ? 10 :
                      account.type.includes('challenge_f2') ? 5 : '';
    }
    if (!maxDrawdown) {
        maxDrawdown = account.type.includes('challenge_f1') ? 10 :
                     account.type.includes('challenge_f2') ? 10 :
                     account.type.includes('funded') ? 10 : '';
    }

    document.getElementById('settingsRoiObjective').value = roiObjective || '';
    document.getElementById('settingsMaxDrawdown').value = maxDrawdown || '';

    // Show warning if account is burned
    const statusWarning = document.getElementById('statusWarning');
    if (statusWarning) {
        if (account.status === 'burned' || account.status === 'superado') {
            statusWarning.style.display = 'block';
        } else {
            statusWarning.style.display = 'none';
        }
    }

    // Reset to first tab
    switchSettingsTab('general');
    
    modal.style.display = 'flex';
}

/* ============================================
   PAYOUTS FUNCTIONALITY
   ============================================ */

// Load payouts for current account
async function loadPayouts() {
    if (!currentAccountIdForSettings || !tursoClient) return;
    
    try {
        const result = await tursoClient.execute({
            sql: `SELECT id, amount, payout_date, notes, created_at 
                  FROM payouts 
                  WHERE account_id = ? 
                  ORDER BY payout_date DESC`,
            args: [currentAccountIdForSettings]
        });
        
        const payouts = result.rows.map(row => ({
            id: row.id,
            amount: row.amount,
            payout_date: row.payout_date,
            notes: row.notes,
            created_at: row.created_at
        }));
        
        renderPayouts(payouts);
        updatePayoutMetrics(payouts);
        populateYearFilter(payouts);
        
    } catch (error) {

    }
}

// Render payouts list
function renderPayouts(payouts) {
    const container = document.getElementById('payoutList');
    if (!container) return;
    
    const yearFilter = document.getElementById('payoutYearFilter')?.value || 'all';
    const monthFilter = document.getElementById('payoutMonthFilter')?.value || 'all';
    
    // Filter payouts
    let filtered = payouts;
    if (yearFilter !== 'all') {
        filtered = filtered.filter(p => new Date(p.payout_date).getFullYear().toString() === yearFilter);
    }
    if (monthFilter !== 'all') {
        filtered = filtered.filter(p => (new Date(p.payout_date).getMonth() + 1).toString() === monthFilter);
    }
    
    if (filtered.length === 0) {
        container.innerHTML = `
            <div class="empty-state">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                <p>No hay retiros registrados</p>
            </div>
        `;
        return;
    }
    
    container.innerHTML = filtered.map(payout => {
        const date = new Date(payout.payout_date);
        const formattedDate = date.toLocaleDateString('es-ES', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
        
        return `
            <div class="payout-item">
                <div class="payout-info">
                    <div class="payout-amount">$${parseFloat(payout.amount).toFixed(2)}</div>
                    <div class="payout-date">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                            <line x1="16" y1="2" x2="16" y2="6"/>
                            <line x1="8" y1="2" x2="8" y2="6"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        ${formattedDate}
                    </div>
                    ${payout.notes ? `<div class="payout-notes">${payout.notes}</div>` : ''}
                </div>
                <div class="payout-actions">
                    <button class="payout-delete-btn" onclick="deletePayout(${payout.id})">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="3 6 5 6 21 6"/>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                        </svg>
                        Eliminar
                    </button>
                </div>
            </div>
        `;
    }).join('');
}

// Update payout metrics
function updatePayoutMetrics(payouts) {
    const totalAmount = payouts.reduce((sum, p) => sum + parseFloat(p.amount), 0);
    const count = payouts.length;
    const avgAmount = count > 0 ? totalAmount / count : 0;
    
    document.getElementById('totalPayoutAmount').textContent = `$${totalAmount.toFixed(2)}`;
    document.getElementById('totalPayoutCount').textContent = count;
    document.getElementById('avgPayoutAmount').textContent = `$${avgAmount.toFixed(2)}`;
}

// Populate year filter
function populateYearFilter(payouts) {
    const yearFilter = document.getElementById('payoutYearFilter');
    if (!yearFilter) return;
    
    const years = [...new Set(payouts.map(p => new Date(p.payout_date).getFullYear()))].sort((a, b) => b - a);
    
    const currentOptions = yearFilter.innerHTML;
    const newOptions = `
        <option value="all">Todos</option>
        ${years.map(year => `<option value="${year}">${year}</option>`).join('')}
    `;
    
    if (currentOptions !== newOptions) {
        yearFilter.innerHTML = newOptions;
    }
}

// Delete payout
window.deletePayout = async function(payoutId) {
    const confirmed = window.showConfirm
        ? await window.showConfirm({
            title: 'Eliminar retiro',
            message: '¿Estás seguro de eliminar este retiro?',
            confirmText: 'Eliminar',
            cancelText: 'Cancelar',
            type: 'warning'
        })
        : false;

    if (!confirmed) return;
    
    try {
        await tursoClient.execute({
            sql: 'DELETE FROM payouts WHERE id = ?',
            args: [payoutId]
        });
        
        showNotification('Retiro eliminado', 'success');
        await loadPayouts();
        
        // Recargar las cards para actualizar el próximo payout
        await loadAllAccounts();
        await renderPerformanceCards();
        
    } catch (error) {
        showNotification('Error al eliminar el retiro', 'error');
    }
}

// Handle payout form submission
document.addEventListener('DOMContentLoaded', () => {
    const payoutForm = document.getElementById('payoutForm');
    if (payoutForm) {
        payoutForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            const amount = document.getElementById('payoutAmount').value;
            const date = document.getElementById('payoutDate').value;
            const notes = document.getElementById('payoutNotes').value;
            
            if (!amount || !date) {
                showNotification('Completa los campos requeridos', 'warning');
                return;
            }
            
            try {
                await tursoClient.execute({
                    sql: `INSERT INTO payouts (account_id, amount, payout_date, notes, created_at)
                          VALUES (?, ?, ?, ?, ?)`,
                    args: [currentAccountIdForSettings, parseFloat(amount), date, notes || null, new Date().toISOString()]
                });
                
                showNotification('Retiro registrado exitosamente', 'success');
                payoutForm.reset();
                await loadPayouts();
                
                // Recargar las cards para actualizar el próximo payout
                await loadAllAccounts();
                await renderPerformanceCards();
                
            } catch (error) {
                showNotification('Error al registrar el retiro', 'error');
            }
        });
    }
    
    // Add event listeners for filters
    const yearFilter = document.getElementById('payoutYearFilter');
    const monthFilter = document.getElementById('payoutMonthFilter');
    
    if (yearFilter) {
        yearFilter.addEventListener('change', () => loadPayouts());
    }
    if (monthFilter) {
        monthFilter.addEventListener('change', () => loadPayouts());
    }
});

/* ============================================
   DAILY NOTES FROM JOURNAL - VISUALIZATION
   ============================================ */

// Load daily notes from journal
async function loadMonthlyNotes() {
    if (!currentAccountIdForSettings || !tursoClient) return;
    
    updateMonthDisplay();
    
    const currentDate = getCurrentMonthDate();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    
    // Calcular primer y último día del mes
    const firstDay = `${year}-${month}-01`;
    const lastDay = new Date(year, currentDate.getMonth() + 1, 0).getDate();
    const lastDayStr = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
    
    try {
        // Cargar todas las notas diarias del mes actual para esta cuenta
        const result = await tursoClient.execute({
            sql: `SELECT date, note, sentiment, day_outcome, created_at 
                  FROM daily_notes 
                  WHERE account_id = ? AND date >= ? AND date <= ?
                  ORDER BY date DESC`,
            args: [currentAccountIdForSettings, firstDay, lastDayStr]
        });
        
        renderDailyNotes(result.rows);
        
    } catch (error) {

    }
}

// Render daily notes
function renderDailyNotes(notes) {
    const container = document.getElementById('dailyNotesList');
    if (!container) return;
    
    if (notes.length === 0) {
        container.innerHTML = `
            <div class="empty-state">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10 9 9 9 8 9"/>
                </svg>
                <p>No hay notas para este mes</p>
                <small style="color: #90a4ae; margin-top: 8px;">Las notas se añaden desde el Journal</small>
            </div>
        `;
        return;
    }
    
    // Emojis para sentimientos
    const sentimentEmojis = {
        'excellent': '🤩',
        'good': '😊',
        'neutral': '😐',
        'bad': '😕',
        'terrible': '😢'
    };
    
    // Emojis para outcomes
    const outcomeEmojis = {
        'win': '✅',
        'loss': '❌',
        'breakeven': '➖'
    };
    
    container.innerHTML = notes.map(note => {
        const date = new Date(note.date);
        const dayName = date.toLocaleDateString('es-ES', { weekday: 'long' });
        const dayNum = date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
        
        const sentimentEmoji = note.sentiment ? sentimentEmojis[note.sentiment] || '📝' : '📝';
        const outcomeEmoji = note.day_outcome ? outcomeEmojis[note.day_outcome] || '' : '';
        
        return `
            <div class="daily-note-item">
                <div class="note-header">
                    <div class="note-date">
                        <span class="note-day">${dayName}</span>
                        <span class="note-day-num">${dayNum}</span>
                    </div>
                    <div class="note-badges">
                        ${outcomeEmoji ? `<span class="note-badge outcome-${note.day_outcome}">${outcomeEmoji} ${note.day_outcome}</span>` : ''}
                        ${sentimentEmoji ? `<span class="note-badge sentiment">${sentimentEmoji}</span>` : ''}
                    </div>
                </div>
                ${note.note ? `<div class="note-content">${note.note}</div>` : '<div class="note-content" style="color: #666; font-style: italic;">Sin nota</div>'}
            </div>
        `;
    }).join('');
}

// Navigate months
window.navigateMonth = function(direction) {
    currentMonthOffset += direction;
    loadMonthlyNotes();
}

// Get current month date based on offset
function getCurrentMonthDate() {
    const date = new Date();
    date.setMonth(date.getMonth() + currentMonthOffset);
    return date;
}

// Funciones asincrónicas para archivar sin recargar página
window.archiveAccountAsync = async function(accountId, accountName) {
    try {
        if (!tursoClient) return;

        const now = new Date().toISOString();
        await tursoClient.execute({
            sql: 'UPDATE accounts SET is_archived = 1, archived_at = ? WHERE id = ?',
            args: [now, accountId]
        });
        
        const displayName = accountName || 'Cuenta';
        showNotification(`Cuenta "${displayName}" archivada. Será eliminada en 48 horas`, 'success', 3000);
        
        // Agregar al notification center
        if (window.NotificationCenter) {
            window.NotificationCenter.add({
                type: 'archive',
                title: 'Cuenta archivada',
                message: `Cuenta "${displayName}" archivada. Será eliminada en 48 horas`,
                icon: '📦'
            });
        }
        
    } catch (error) {
    }
};

// Variable para evitar múltiples llamadas simultáneas de toggle archive
let archiveToggleInProgress = false;

window.toggleArchiveAccountAsync = async function(accountId, accountName, isArchived) {
    // Evitar múltiples llamadas simultáneas
    if (archiveToggleInProgress) return;
    archiveToggleInProgress = true;
    
    try {
        if (!tursoClient) return;

        const now = new Date().toISOString();
        const displayName = accountName || 'Cuenta';
        
        if (isArchived) {
            // Archivar
            await tursoClient.execute({
                sql: 'UPDATE accounts SET is_archived = 1, archived_at = ? WHERE id = ?',
                args: [now, accountId]
            });
            showNotification(`Cuenta "${displayName}" archivada. Será eliminada en 48 horas`, 'success', 3000);
            
            // Agregar al notification center
            if (window.NotificationCenter) {
                window.NotificationCenter.add({
                    type: 'archive',
                    title: 'Cuenta archivada',
                    message: `Cuenta "${displayName}" archivada. Será eliminada en 48 horas`,
                    icon: '📦'
                });
            }
        } else {
            // Desarchiver
            await tursoClient.execute({
                sql: 'UPDATE accounts SET is_archived = 0, archived_at = NULL WHERE id = ?',
                args: [accountId]
            });
            showNotification(`Cuenta "${displayName}" desarchivada`, 'success', 3000);
            
            // Agregar al notification center
            if (window.NotificationCenter) {
                window.NotificationCenter.add({
                    type: 'restore',
                    title: 'Cuenta desarchivada',
                    message: `Cuenta "${displayName}" desarchivada`,
                    icon: '✅'
                });
            }
        }
        
    } catch (error) {
    } finally {
        archiveToggleInProgress = false;
    }
};

// Update month display
function updateMonthDisplay() {
    const display = document.getElementById('currentMonthDisplay');
    if (!display) return;
    
    const date = getCurrentMonthDate();
    const monthName = date.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
    display.textContent = monthName.charAt(0).toUpperCase() + monthName.slice(1);
}

/**
 * Actualiza el badge del notificationBtn cuando hay nuevas notificaciones
 */
function updateNotificationBadge() {
    const notificationBadge = document.getElementById('notificationBadge');
    const notificationCount = document.getElementById('notificationCount');
    
    if (notificationBadge && notificationCount) {
        // Mostrar el badge rojo
        notificationBadge.classList.remove('hidden');
        
        // Si hay contador, incrementarlo
        let count = parseInt(notificationCount.textContent) || 0;
        count++;
        notificationCount.textContent = count > 9 ? '9+' : count;
        notificationCount.classList.remove('hidden');
        
        // Auto-ocultar el badge después de 10 segundos
        setTimeout(() => {
            notificationBadge.classList.add('hidden');
            if (count <= 1) {
                notificationCount.classList.add('hidden');
            } else {
                notificationCount.textContent = count - 1;
            }
        }, 10000);
    }
}
